export const locale = {
  general_menu_settings: 'Genel Menü Ayarları',
  settings: {
  business_type_title: 'Menü İşletme Türünü Seçin',
  currency_label: 'Para Birimi',
  show_filter: 'Ürün Filtresini Göster',
  show_categories: 'Ürün Kategorilerini Göster',
  
  business_types: {
    cafe: 'Kafe',
    restaurant: 'Restoran',
    fastfood: 'Fast Food',
    icecream: 'Meyve Suyu & Dondurma',
    sweets: 'Tatlılar & Tatlılar',
    bakery: 'Fırın'
  },
  
  custom_labels: {
    ph_menu_cafe: 'Kafe Menüsü',
    ph_menu_restaurant: 'Yemek Menüsü',
    ph_menu_fastfood: 'Fast Food Menüsü',
    ph_menu_icecream: 'Meyve Suyu ve Dondurma',
    ph_menu_sweets: 'Kek ve Tatlılar',
    ph_menu_bakery: 'Ekmek ve Unlu Mamuller',
    ph_product_list: 'Ürünler',
    ph_add_order: 'Ekle',
    ph_add_cart: 'Satın Al',

    title: 'Etiketleri Özelleştir (İsteğe Bağlı)',
    subtitle: 'Varsayılan sistem terimlerini kendi tercih ettiğiniz kelimelerle değiştirin.',
    products_title: 'Ürünler Bölüm Başlığı',
    ph_food_menu: 'örn. Yemek Menüsü',
    ph_product_list: 'örn. Ürün Listesi',
    cart_btn: 'Ödeme Düğmesi Metni',
    ph_add_order: 'örn. Siparişe Ekle',
    ph_add_cart: 'örn. Sepete Ekle'
  },

  currencies: {
    toman: 'Tümen',
    rial: 'Riyal'
  }
},
check_account_balance_and_try_again: 'Lütfen hesap bakiyenizi kontrol edip tekrar deneyin',
problem_with_qr_renewal_request: 'QR kod yenileme talebi sırasında bir sorun oluştu',

  ERRORS: {
    PhoneIsNotValid: "Girilen telefon numarası geçersiz: örn. 09101234567",
    InvalidNumber: "Girilen miktar geçersiz.",
    NoSelectedLineNumber: "Lütfen gönderici hattını seçin.",
    EmptyText: "Lütfen metni girin.",
    UnknownError: "Bilinmeyen hata",
    TryAgain: "Lütfen daha sonra tekrar deneyin.",
    NoAccountCharge: "Yetersiz bakiye",
    NoAccess: "Erişim reddedildi.",
    PleasebyeAPlane: "Lütfen bir plan satın alın.",
    PleaseChargeYourAccount: "Lütfen hesabınıza bakiye yükleyin.",
    AccessDenied: "Erişim reddedildi.",
    AccessDeniedDescription:
      "Daha fazla bilgi için destek ile iletişime geçin.",
    Error: "Hata",
    InvalidText: "Geçersiz metin",
    InvalidTextContainsLink: "Sadece hizmet hatları bağlantı içerebilir.",
    NoPhoneToSend: "Gönderilecek numara yok.",
  },
  FORMS: {
    SuccsessFullySended: "Anladım",
    DestinationPhone: "Alıcı telefon numarası",
    TestDestinationPhone: "Test telefon numarası",
    SourceNumber: "Gönderici numarası",
    Text: "Metin",
    CharCount: "Karakter sayısı",
    FarsiCharCount: "Farsça karakter sayısı",
    EnglishCharCount: "İngilizce karakter sayısı",
    Send: "Gönder",
    SendTime: "Gönderim zamanı",
    SendTest: "Test gönderimi",
    SendToTestNumber: "Test numarasına gönder",
    SmsCount: "SMS sayısı",
    SmsLang: "SMS dili",
    Add: "Ekle",
    FromFile: "Dosyadan ekle",
    TestNumber: "Test numarası",
    Test: "Test",
    ServiceRelated: "Hizmet/İşlem",
    Price: "Beyaz liste gönderim ücreti",
    TotalPrice: "Toplam ücret",
    NumbersCount: "Toplam numara sayısı",
    BlacklistPrice: "Kara liste gönderim ücreti",
    BlacklistNumbersCount: "Kara liste sayısı",
    WhitelistNumbersCount: "Beyaz liste sayısı",
    IrancellNumbersBlacklistCount: "Irancell kara liste sayısı",
    HamrahavalNumbersBlacklistCount: "Hamrah Aval kara liste sayısı",
    IrancellNumbersWhitelistCount: "Irancell beyaz liste sayısı",
    HamrahavalNumbersWhitelistCount: "Hamrah Aval beyaz liste sayısı",
    NumbersCountToSend: "Geçerli numara sayısı",
    Search: "Ara",
    Title: "Başlık",
    RequestTime: "İstek zamanı",
    RequestInformation: "İstek bilgisi",
    CreateNewPhoneBook: "Yeni telefon rehberi oluştur",
    AddPhone: "Numaraları ekle",
    Remove: "Kaldır",
  },
  luck_wheel_name: "Şans Çarkı QR Adı",
  update_video: "Video Galerisi Ekle",
  edit: "Düzenle",
  to_top: "Yukarıdan",
  to_bottom: "Aşağıdan",
  to_left: "Sağdan sola",
  to_right: "Soldan sağa",
  to_top_right: "Aşağıdan sağa",
  to_top_left: "Aşağıdan sola",
  to_bottom_right: "Yukarıdan sağa",
  to_bottom_left: "Yukarıdan sola",
  select_color_gradient: "Gradyan rengi seç",
  select_color_solid: "Düz renk seç",
  gradient_direction: "Gradyan yönü",
  gradient_background: "Gradyan arka plan",
  qr_downloaded_successfully: "QR başarıyla indirildi.",
  logo: "Logo",
  qr_design_size: "QR tasarımı ve boyutu",
  qr_eye_design: "QR göz tasarımı",
  qr_markout: "Çıkış kenar boşluğu",
  frame: "Çerçeve",
  ready_card_samples: "Hazır kartvizit örnekleri",
  ready_card_sample: "Hazır kartvizit örneği",
  remove_default_info: "Varsayılan bilgileri kaldır",
  select_ready_card: "Hazır kartvizit seç",
  connection_code: "Bağlantı kodu",
  enter_visit_card_info: "Kartvizit bilgilerini girin",
  info: "Bilgiler",
  select_template_design: "Şablon tasarımı seç",
  qr_address: "QR adresi",
  visit_card_name: "Kartvizitinizin adı",
  visit_card_name_pro: "Kartvizitinizin adı Pro",
  download_qr: "QR indir",
  fast_design: "Hızlı tasarım",
  professional_design: "Profesyonel tasarım",
  ai_design: "Yapay zeka tasarımı",
  update_qr: "QR'yi güncelle",
  fast_design_message:
    "Hızlı kod tasarımına geçtiniz. Önceki tasarımı bu bölümde yaptınız.",
  professional_design_message:
    "Profesyonel kod tasarımına geçtiniz. Önceki tasarımı bu bölümde yaptınız.",
  scan_me: "Beni tara",
  visit_card_edited_successfully: "Kartvizitiniz başarıyla düzenlendi.",
  customer_club_membership: "Müşteri kulübü üyeliği",
  qrland: "QR Land",
  dynamic: "Dinamik",
  about_us_text:
    "Dinamik QR kod özellikleri:\n✔️ Sınırsız düzenleme\n✔️ Kolay tarama\n✔️ Tarama sınırlama\n✔️ Şifre ekleme\n✔️ Ziyaretçi istatistiklerini görüntüleme\n✔️ QR renk ve görünüm değiştirme\n✔️ Bilgi ve güvenlik koruma\n✔️ QR'ye fotoğraf ve logo ekleme\n✔️ İşletmeye özel QR ekleme\n✔️ Tarayıcıyı linklere ve siteye yönlendirme\n✔️ QR ve kısa link birlikte sunma\n✔️ Tüm sosyal ağlarda (çevrimdışı/çevrimiçi) kullanılabilir\n✔️ İstediğin formatta indirilebilir\n✔️ Her yüzeye ve boyuta basılabilir",
  video_gallery: "Video galerisi",
  address_text: "İstanbul, Şişli, Halaskargazi Cd., No: 6",
  visit_card: "Kartvizit",
  qrland_system: "QR Land sistemi",
  qrland_first_system: "İlk dinamik QR kod oluşturma sistemi",
  address: "Adres",
  enter_site_link: "İstediğiniz site linkini girin",
  instagram: "Instagram",
  enter_instagram_username: "Kullanıcı adınızı girin",
  whatsapp: "WhatsApp",
  invalid_qr_address: "Girilen adres geçerli değil!",
  visit_card_created_successfully: "Kartvizitiniz başarıyla oluşturuldu.",
  qr_creation_failed: "QR oluşturma hatayla karşılaştı!",
  manage_password: "Şifre yönetimi",
  hour_limit: "Saat sınırı",
  scan_click_limit: "Tarama/tıklama sınırı",
  redirect_scanner: "Tarayıcıyı yönlendir",
  edit_settings_error: "Ayarlar düzenlenirken hata oluştu!",
  next: "İleri",
  add: "Ekle",
  header_color_settings: "Başlık rengi ve metin ayarları",
  select_image: "Resim seç",
  enter_qr_address: "QR adresinizi girin",
  qr_idea_title: "QR oluşturma fikri",
  qr_idea: "QR fikri",
  qr_idea_subject: "QR oluşturma konusu",
  confirm_qr_idea: "QR fikrimi onayla",
  scannable: "Taranabilir",
  ai_sample: "Yapay zeka örneği...",
  scan_warning: "Tüm cihazlarda taranmayabilir. Tarama olmazsa tekrar deneyin.",
  ai_description:
    "İstediğiniz QR açıklamasını girin, yapay zeka sizin için oluştursun.",
  attach: "Ekle",
  remaining: "Kalan",
  qr_creation: "QR oluşturma",
  free: "Ücretsiz",
  select_language_for_request: "İstek metni için dil seç",
  request_text: "İstek metni",
  request_text_placeholder: "İstediğiniz QR linkini tarif edin...",
  strengthen_text: "Mevcut metni güçlendir",
  prompt_idea: "Prompt fikri",
  try_again: "Tekrar dene",
  create_qr: "QR oluştur",
  smart_qr_code: "Akıllı QR kod",
  regenerate_image: "Resmi yeniden oluştur",
  updating_qr: "QR güncelleniyor...",
  copied: "Kopyalandı",
  copy: "Kopyala",
  print_qr: "QR yazdır",
  print_visit_card: "Kartviziti yazdır",
  send_link: "Link gönder",
  customer_list: "Müşteri listesi",
  order_list: "Sipariş listesi",
  reserved_appointments: "Rezerve edilen randevular",
  feedback: "Geri bildirim",
  request_form: "İstek formu",
  transfer_ownership: "Mülkiyeti devret",
  select_nfc_card: "NFC kart seç",
  created_at: "Oluşturulma",
  last_edit: "Son düzenleme",
  qr_card: "QR kartı",
  viewed: "Görüntülendi",
  see_more: "Daha fazla gör",
  download: "İndir",
  activate: "Etkinleştir",
  design: "Tasarım",
  qr_settings: "QR ayarları",
  deactivate: "Devre dışı bırak",
  qr_color_size: "QR renk ve boyutu",
  dots_design_color: "Nokta tasarımı ve rengi",
  eye_design_color: "Göz tasarımı ve rengi",
  border_design_color: "Kenarlık tasarımı ve rengi",
  logo_settings: "Logo ayarları",
  download_qr_comment: "QR indir",
  connection_established: "Bağlantı kuruldu.",
  show_qr: "QR göster",
  preview: "Önizleme",
  user_info: "Kullanıcı bilgileri",
  sms_club_membership: "SMS kulübü üyeliği",
  smart_settings: "Akıllı ayarlar",
  add_audio_file: "Ses dosyası ekle",
  back: "Geri",
  after_click_location: "Konuma tıkladıktan sonra harita uygulamanızı seçin.",
  phone_number: "Telefon numarası",
  auto_display: "Otomatik gösterim",
  customer_club: "Müşteri kulübü",
  auto_download: "Otomatik indirme",
  save: "Kaydet",
  about_us: "Hakkımızda",
  view_more: "Daha fazla gör",
  view_less: "Daha az gör",
  audio_file: "Ses dosyası",
  add_video: "Video ekle",
  add_image: "Resim ekle",
  select_color: "Renk seç",
  header_color: "Başlık metni",
  add_social_networks: "Sosyal ağlar ekle",
  format: "Biçim",
  output_size: "Çıkış boyutu",
  file_type: "Dosya türü",
  default: "Varsayılan",
  qr_download_error: "QR indirilirken sorun oluştu. Tekrar deneyin",
  header_color_text_settings: "Başlık rengi ve metin ayarları",
  upload_catalog_images: "Katalog / broşür görselleri yükle",
  delete: "Sil",
  personal_domain: "Kişisel alan adı",
  no_domain_found: "Alan adı bulunamadı!",
  enter_domain_address: "Lütfen alan adı adresinizi girin",
  dns_setup_note: "Önce sunucu DNS ayarlarını yapmalısınız!",
  attention: "Dikkat: ",
  dns_setup_instruction: "Kişisel alan adı kaydetmek için önce DNS'leri",
  and: "ve",
  setup_on_domain: "alan adınıza ayarlayın.",
  dns_change_time: "(DNS değişikliği en fazla 24 saat sürer)",
  add_domain: "Alan adı ekle",
  add_personal_domain: "Kişisel alan adı ekle",
  min_characters: "Minimum giriş karakteri",
  domain_format:
    "Site alan adı https://terminalads.com veya terminalads.com şeklinde olmalıdır.",
  invalid_domain: "Girilen alan adı geçerli değil!",
  domain_added_successfully: "Alan adınız başarıyla eklendi",
  invalid_dns_settings: "DNS ayarları geçerli değil!",
  deleted_successfully: "Başarıyla silindi",
  location: "Konum",
  save_contact: "Kişiyi kaydet",
  search: "Ara",
  data_fetch_error: "Veri alınırken hata oluştu!",
  error: "Hata",
  view_qr: "QR görüntüle",
  qr_design: "QR tasarımı",
  register: "Kayıt ol",
  terminal_ads: "Terminal Reklam",
  manage_40_advertising_methods: "40 reklam yöntemini aynı anda yönet!",
  ms_khansari: "Bayan Hansari",
  support: "Destek",
  comprehensive_advertising_system:
    "Çevrimiçi reklamları inceleyen ve yöneten tek kapsamlı sistem",
  terminal_ads_description:
    "Terminal Reklam sistemi, müşterileri ve kullanıcılarıyla sürekli ve etkili iletişim kurarak ihtiyaçlarını anlamayı ve en iyi çözümleri sunmayı amaçlar. En büyük sermayemiz sadık müşterilerimiz ve kullanıcılarımızdır; ardından yeni fikirler ve modern teknolojilerle şirketi destekleyen uzman ekibimiz gelir.",
  please_enter_qr_address_correctly: "Lütfen QR adresini doğru girin!",
  server_error: "Sunucu hatası!",
  please_enter_your_address: "Lütfen adresinizi girin",
  please_enter_instagram_address: "Lütfen Instagram adresinizi girin",
  please_enter_whatsapp_address: "Lütfen WhatsApp adresinizi girin",
  enter_information: "Bilgi girin",
  dynamic_qr: "Dinamik QR olsun",
  coming_soon: "Yakında",
  qr_name: "QR adı",
  for_default_address_leave_empty: "!Varsayılan adres için boş bırakın",
  default_address: "Varsayılan adres",
  sms: "SMS",
  enter_number_without_zero: "Numarayı 0 olmadan girin.",
  number: "Numara",
  country_code: "Ülke kodu",
  sms_text: "SMS metni",
  complete_sms_fields_correctly: "Lütfen SMS alanlarını doğru doldurun!",
  qr_code_created_successfully: "QR kodunuz başarıyla oluşturuldu.",
  chat: "Sohbet",
  call: "Ara",
  please_enter_username: "Lütfen kullanıcı adınızı girin.",
  username: "Kullanıcı adı",
  sample_menu: "Örnek Menü",
  online_menu_name: "Online menü adınız",
  online_menu_name_short: "Online Menü",
  enter_menu_information: "Menü bilgilerini girin",
  select_sample_menu: "Örnek menü seçin",
  select_ready_menu: "Hazır menü seçin",
  online_sales: "Online Satışlar",
  sales_settings: "Satış Ayarları",
  photo_gallery: "Fotoğraf Galerisi",
  fast_food1: "Fast Food 1",
  fast_food2: "Fast Food 2",
  products: "Ürünler",
  pizzas: "Pizzalar",
  pizza_rust_beef: "Kızarmış Dana Etli Pizza",
  italian_pizza_with_beef: "İtalyan Dana Etli Pizza",
  italian_pizza_dough_30cm: "İtalyan Pizza Hamuru 30 cm",
  "100g_shredded_beef": "100 g rendelenmiş dana eti",
  mushroom_bell_pepper: "Mantar, dolmalık biber",
  black_olives: "Siyah zeytin",
  pizza_chicken_mushroom: "Tavuk ve Mantarlı Pizza",
  classic_40cm: "Klasik 40 cm",
  fresh_tomato_sauce:
    "Taze domates sosu, peynir, tavuk fileto, mantar, dağ kekiği",
  pizza_meat_mushroom: "Et ve Mantarlı Pizza",
  meat_pizza_with_mushroom: "Kıymalı ve Mantarlı Pizza",
  pizza_vegetables: "Sebzeli Pizza",
  american_vegetable_pizza: "Amerikan Sebzeli Pizza",
  american_pizza_dough:
    "Amerikan pizza hamuru, mısır, mantar, zeytin, domates, soğan, biber, peynir",
  special_pizza: "Özel Pizza",
  american_special_pizza: "Amerikan Özel Pizza",
  pizza_bolognese: "Bolognese Pizza",
  one_person_23cm: "(1 kişi) Pizza hamuru 23 cm",
  pepperoni_pizza: "Pepperoni Pizza",
  one_person_23cm_dough: "(1 kişi) Pizza hamuru 23 cm",
  bacon_pizza: "Pastırmalı Pizza",
  one_person_23cm_explosion: "(1 kişi) Pizza hamuru 23 cm",
  mixed_pizza: "Karışık Pizza",
  one_person_23cm_mixed: "(1 kişi) Pizza hamuru 23 cm",
  american_steak_pizza: "Amerikan Biftekli Pizza",
  one_person_23cm_steak: "(1 kişi) 23 cm",
  burgers: "Burgerler",
  cheese_burger: "Peynirli Burger",
  with_french_fries: "patates kızartması ile",
  "2_beef_burgers_150g": "2 adet 150 g dana burger",
  special_sauce_gouda_cheese: "Özel sos, Gouda peyniri",
  pickles_lettuce_tomato: "Turşu, marul, domates",
  special_sauce: "Özel sos",
  burger: "Burger",
  pure_meat_with_special_sauce: "Özel soslu saf et",
  chicken_burger: "Tavuk Burger",
  grilled_chicken_burger_with_cheese: "Izgara tavuklu peynirli burger",
  spicy_burger: "Acılı Burger",
  beef_with_spicy_sauce: "Acılı soslu dana eti",
  double_burger: "Çift Burger",
  "150g_beef": "150 g dana eti",
  royal_burger: "Kral Burger",
  "150g_beef_emoji": "150 g dana eti",
  mushroom_burger: "Mantarlı Burger",
  "150g_beef_mushroom": "150 g dana eti mantarlı",
  mushroom_burger_grilled: "Izgara Mantarlı Burger",
  "100_percent_grilled_beef": "%100 ızgara dana eti",
  fried_burger: "Kızarmış Burger",
  "100_percent_grilled_fried": "%100 ızgara ve kızarmış dana eti",
  fried: "Kızarmış",
  fried_chicken: "Kızarmış Tavuk",
  "3_piece_fried_chicken": "3 parça kızarmış tavuk",
  "3_fried_chicken_pieces": "3 adet kızarmış tavuk parçası",
  "120_150g_french_fries": "120-150 g patates kızartması",
  enter_product_information: "Ürün bilgilerini girin",
  product_name: "Ürün adınız",
  product_name_short: "Ürün Adı",
  complete_features_from_image: "Ürün görseline göre özellikleri doldurun",
  skip_step: "Adımı atla",
  product_and_information: "Ürün ve Bilgi",
  product_introduction: "Ürün Tanıtımı",
  shiva_waves: "Şiva Dalgaları",
  think_best: "En iyisini düşün...",
  iran_zanjan_abhar:
    "İran, Zencan, Abhar, Şerif Sanayi Bölgesi, 63/20 kV trafo merkezi yanı",
  video_gallery_description: "Videolarımızı izleyin.",
  gallery: "Galeri",
  welcome: "Hoş geldiniz",
  invalid_address: "Girilen adres geçersiz!",
  product_created_successfully: "Ürününüz başarıyla oluşturuldu.",
  qr_visit_card_edited_successfully: "Kartvizitiniz başarıyla düzenlendi.",
  change_header_color: "Başlık rengini değiştir",
  change_body_color: "Gövde rengini değiştir",
  change_button_colors: "Düğme renklerini değiştir",
  change_text_colors: "Metin renklerini değiştir",
  gradient_colors: "Gradyan renkler",
  color_direction: "Renk yönü",
  first_color: "Birinci renk",
  second_color: "İkinci renk",
  color: "Renk",
  text_color: "Metin rengi",
  from_top: "Yukarıdan",
  from_bottom: "Aşağıdan",
  from_left_to_right: "Soldan sağa",
  from_right_to_left: "Sağdan sola",
  from_top_to_left: "Yukarı soldan",
  from_top_to_right: "Yukarı sağdan",
  from_bottom_to_left: "Aşağı soldan",
  from_bottom_to_right: "Aşağı sağdan",
  sharing: "Paylaş",
  business_shop: "İş / Mağaza",
  corporate_organizational: "Şirket / Kurumsal",
  customer_contact: "Müşteri İletişim",
  information: "Bilgi",
  miscellaneous: "Çeşitli",
  link: "Bağlantı",
  margin: "Kenar boşluğu",
  width: "Genişlik",
  height: "Yükseklik",
  background_color: "Arka plan rengi",
  gradient_color: "Gradyan renk",
  linear: "Doğrusal",
  radial: "Radyal",
  color_rotation: "Renk döndürme",
  background_color_label: "Arka plan rengi",
  dots_color: "Nokta rengi",
  dots_color_label: "Nokta rengi",
  eye_colors: "Göz renkleri",
  separate_colors_for_each_eye: "Her göz için ayrı renk",
  current_mode: "Mevcut mod:",
  separate_colors: "Ayrı renkler",
  same_color: "Aynı renk",
  all_eyes_color: "Tüm gözlerin rengi",
  top_right_eye: "Üst sağ göz",
  top_left_eye: "Üst sol göz",
  bottom_left_eye: "Alt sol göz",
  upload_logo: "Logo yükle",
  hide_background_dots: "Logo arkasındaki noktaları gizle",
  logo_size: "Logo boyutu",
  logo_margin: "Logo kenar boşluğu",
  qr_accuracy: "QR hassasiyeti",
  mode: "Mod",
  error_correction_level: "Hata düzeltme seviyesi",
  numeric: "Sayısal",
  alphanumeric: "Alfasayısal",
  byte: "Bayt",
  apply_changes: "Değişiklikleri uygula",
  please_click_apply_changes:
    "Değişiklik yaptıktan sonra 'Değişiklikleri uygula' butonuna tıklayın.",
  created_qr_codes: "Oluşturulan QR kodları",
  square_ratio: "1:1 (kare)",
  image_upload_error: "Görsel yükleme hatası!",
  visit_card_name_label: "Kartvizit adı",
  sms_membership_message: "Müşteri kulübü üyeliği SMS mesajı",
  admin_menu: "Yönetici Menüsü",
  user_menu: "Kullanıcı Menüsü",
  guide_tooltip: "Kılavuz",
  close: "Kapat",
  browser_video_support_error:
    "Tarayıcınız hiçbir video formatını desteklemiyor.",
  video_loading_error: "Video yükleme hatası (erişim kısıtlı olabilir).",
  click_more_for_videos: "Daha fazla video için «Daha Fazla»ya tıklayın.",
  more_info: "Daha fazla bilgi",
  more: "Daha Fazla",
  add_user_guide: "Kullanıcı kılavuzu ekle",
  edit_user_guide: "Kullanıcı kılavuzunu düzenle",
  display_info: "Bilgiyi göster",
  element: "Eleman",
  disable_attach: "Sayfaya sığdırmak için sabitlemeyi devre dışı bırak",
  view: "Görünüm",
  guide: "Kılavuz",
  details: "Detaylar",
  guide_images: "Kılavuz görselleri",
  guide_videos: "Kılavuz videoları",
  faq: "Sıkça Sorulan Sorular",
  data_preload_error: "Veri ön yükleme hatası:",
  guide_not_found: "Kılavuz bulunamadı. Önce kılavuz oluşturun.",
  delete_guide_question: "Kılavuzu sil?",
  delete_guide_error: "Kılavuz silme hatası!",
  unknown_file_type: "Bilinmeyen dosya türü:",
  content_type_error: "İçerik türü alınamadı:",
  video: "Video",
  image: "Görsel",
  guide_data_error: "Kılavuz verisi alınamadı:",
  add_iranian_stores: "İran mağazaları ekle",
  add_foreign_stores: "Yabancı mağazalar ekle",
  bazaar: "Bazaar",
  myket: "Myket",
  app_store: "App Store",
  google_play: "Google Play",
  samsung_store: "Samsung Store",
  xiaomi_store: "Xiaomi Store",
  vivo_store: "Vivo Store",
  amazon_store: "Amazon Store",
  bazaar_app: "Bazaar Uygulaması",
  bazaar_link_placeholder: "Bazaar uygulama bağlantısını girin",
  bazaar_link_hint:
    "Geçerli bir Bazaar bağlantısı girin (örnek: https://cafebazaar.ir/app/com.abankefarda)",
  myket_app: "Myket Uygulaması",
  myket_link_placeholder: "Myket uygulama bağlantısını girin",
  myket_link_hint:
    "Geçerli bir Myket bağlantısı girin (örnek: myket://details?id=com.example)",
  app_store_app: "App Store Uygulaması",
  app_store_link_placeholder: "App Store uygulama bağlantısını girin",
  app_store_link_hint:
    "Geçerli bir App Store bağlantısı girin (örnek: https://apps.apple.com/us/app/appname/id123456789)",
  google_play_app: "Google Play Uygulaması",
  google_play_link_placeholder: "Google Play uygulama bağlantısını girin",
  google_play_link_hint:
    "Geçerli bir Google Play bağlantısı girin (örnek: https://play.google.com/store/apps/details?id=com.example)",
  samsung_store_app: "Samsung Store Uygulaması",
  samsung_store_link_placeholder: "Samsung Store uygulama bağlantısını girin",
  samsung_store_link_hint:
    "Geçerli bir Samsung Store bağlantısı girin (örnek: https://galaxy.store/appname)",
  xiaomi_store_app: "Xiaomi Store Uygulaması",
  xiaomi_store_link_placeholder: "Xiaomi Store uygulama bağlantısını girin",
  xiaomi_store_link_hint: "Geçerli bir Xiaomi Store bağlantısı girin",
  vivo_app_store: "Vivo App Store",
  vivo_app_store_app: "Vivo App Store Uygulaması",
  vivo_app_store_link_placeholder: "Vivo App Store uygulama bağlantısını girin",
  vivo_app_store_link_hint: "Geçerli bir Vivo App Store bağlantısı girin",
  amazon_store_app: "Amazon Store Uygulaması",
  amazon_store_link_placeholder: "Amazon Store uygulama bağlantısını girin",
  amazon_store_link_hint: "Geçerli bir Amazon Store bağlantısı girin",
  iranian_store: "İran Mağazası",
  foreign_store: "Yabancı Mağaza",
  personal_store: "Kişisel Mağaza",
  image_logo: "Görsel/Logo",
  image_gallery: "Görsel Galerisi",
  header_image: "Başlık Görseli",
  template_background_image: "Şablon Arka Plan Görseli",
  background_image: "Arka Plan Görseli",
  background_image_alt: "Arka Plan Görseli",
  logo_upload: "Logo yükle",
  welcome_image: "Hoş Geldin Görseli",
  welcome_image_logo_upload: "Hoş geldin görseli/logo yükle",
  loading_animation: "Yükleme Animasyonu",
  preview_welcome_page: "Hoş geldin sayfası önizleme",
  max_background_size: "Maksimum arka plan görsel boyutu: 2 MB.",
  max_logo_size: "Maksimum logo boyutu: 2 MB.",
  scale_from_center: "Merkezden ölçekle",
  slide_from_left: "Soldan kaydır",
  slide_from_top: "Yukarıdan kaydır",
  fade: "Soldurma",
  select_music_card: "Müzik kartı seç",
  show_audio: "Ses göster",
  hide_audio: "Ses gizle",
  add_voice: "Ses ekle",
  max_files_limit: "{count} dosyadan fazla seçemezsiniz!",
  files_not_allowed: "Dosyalar izin verilmiyor!",
  voice_gallery: "Ses Galerisi",
  edit_voice: "Sesi düzenle",
  list: "Liste",
  file_name: "Dosya adı",
  title: "Başlık",
  description: "Açıklama",
  selectdate: "Tarih seç",
  background: "Arka plan",
  text: "Metin",
  delete_audio_confirm:
    "Ses dosyasını galerinize eklemekten kaldırmak istediğinizden emin misiniz?",
  add_voice_gallery: "Ses galerisi ekle",
  gallery_number: "Galeri",
  delete_confirm: "Silmek istediğinizden emin misiniz?",
  confirm: "Onayla",
  voice_gallery_title_hint: "Ses galeri başlığınızı girin.",
  voice_gallery_title: "Başlık",
  voice_gallery_subtitle_hint: "Ses galeri alt başlığınızı girin.",
  voice_gallery_subtitle: "Ses galerisi alt başlığı",
  voice_gallery_subtitle_alt: "Alt başlık",
  website_address_hint: "Web sitenizin adresini girin.",
  website_address: "Web sitesi adresi",
  about_voice_gallery: "Galeri hakkında",
  about_voice_gallery_alt: "Galeri hakkında",
  button_name_hint: "Düğme adını girin.",
  button_name: "Düğme adı",
  domain_format_hint:
    "Alan adı https://terminalads.com veya terminalads.com olmalıdır.",
  about_us_alt: "Hakkımızda",
  add_default_form: "Varsayılan form ekle",
  delete_all: "Tümünü sil",
  validation_active: "Doğrulama: Aktif",
  validation_inactive: "Doğrulama: Pasif",
  validation: "Doğrulama",
  clear_form: "Formu temizle",
  status: "Durum",
  active: "Aktif",
  inactive: "Pasif",
  optional: "İsteğe bağlı",
  required: "Zorunlu",
  question_title: "Başlık",
  question_title_hint: "Soru başlığını girin",
  options_hint: "Seçenekleri yazın ve eklemek için Enter tuşuna basın",
  options: "Seçenekler",
  add_suggested_form: "Önerilen form ekle",
  save_changes: "Değişiklikleri kaydet",
  add_request_field: "İstek alanı ekle",
  select_form_type: "Form türünü seç",
  select_form_type_placeholder: "Form türünü seç",
  dropdown: "Açılır liste",
  text_field: "Metin alanı",
  number_field: "Sayı alanı",
  textarea_field: "Metin kutusu",
  date_field: "Tarih alanı",
  field_name_required: "Alan adı boş olamaz",
  field_name: "Alan adı",
  add_field_name: "Alan adı ekle",
  field_label: "Alan etiketi",
  add_field_label: "Alan etiketi ekle",
  advanced_settings: "Gelişmiş ayarlar",
  select_input_pattern: "Giriş şablonu seç",
  select_input_pattern_placeholder: "Giriş şablonu seç",
  max_characters: "Maksimum karakter",
  min_input_error: "Minimum giriş 0 olmalıdır",
  name_field: "Ad",
  field_type: "Alan türü",
  persian_limit: "Farsça sınırı",
  family_name: "Soyad",
  mobile_number: "Cep telefonu numarası",
  number_limit: "Sayı sınırı",
  national_code: "Ulusal kod",
  meli_code: "Ulusal kod",
  email: "E-posta",
  email_limit: "E-posta sınırı",
  dropdown_field: "Açılır liste alanı",
  english_limit: "İngilizce sınırı",
  mix_per_eng_limit: "Farsça ve İngilizce karışım sınırı",
  site_limit: "Site sınırı",
  form_added_successfully: "Yeni form başarıyla eklendi",
  form_updated_successfully: "Form başarıyla güncellendi",
  delete_item_confirm: "Öğeyi silmek istediğinizden emin misiniz?",
  default_form_added_successfully: "Varsayılan form başarıyla eklendi",
  resources_upload_error: "Kaynak yükleme hatası",
  update_value_if_duplicate: "Tekrar durumunda değeri güncelle",
  first_tab: "İlk sekme",
  display_count: "Görüntüleme sayısı",
  buy_renew_qr_instruction:
    "QR satın almak/yenilemek için son kullanma tarihine tıklayın.",
  days_until_expiry: "Sona ermeye kalan gün",
  expired: "Süresi doldu",
  no_qr_to_display: "Görüntülenecek QR yok!",
  second_tab: "İkinci sekme",
  total_qr_codes: "Toplam QR kodları",
  select_all: "Tümünü seç",
  selected_qr_codes_count: "Seçilen QR kod sayısı",
  qr_codes_count: "QR kod sayısı",
  group_renewal_instruction:
    "Toplu yenileme için istediğiniz QR kodlarını seçin.",
  no_qr_found_with_filters: "Bu filtrelerle QR bulunamadı!",
  qr_codes_count_label: "QR kod sayısı:",
  renew_qr: "QR yenile",
  days: "Gün",
  buy_now: "Şimdi satın al!",
  buy_now_label: "Satın al",
  add_discount_code: "İndirim kodu ekle",
  use_discount_code: "İndirim kodunu kullan",
  discount_code: "İndirim kodu",
  submit: "Gönder",
  my_qr_list: "QR listem",
  group_renewal: "Toplu yenileme",
  row: "Satır",
  type: "Tür",
  clicks: "Tıklama",
  created_at_diff: "Oluşturma zamanı",
  updated_at_diff: "Güncelleme zamanı",
  table_view: "Tablo görünümü",
  normal_view: "Normal görünüm",
  no_qr_or_id_selected: "QR veya ID seçilmedi!",
  qr_updated_successfully: "QR başarıyla güncellendi.",
  qr_update_error: "QR güncelleme hatası!",
  no_qr_selected: "QR seçilmedi!",
  no_qr_code_selected: "QR kodu seçilmedi!",
  success: "Başarılı",
  qrs_upgraded_successfully: "QR'larınız başarıyla yükseltildi.",
  qr_renewal_error: "QR yenileme isteği sorunu!",
  changed_successfully: "Başarıyla değiştirildi.",
  error_occurred: "Bir hata oluştu!",
  no_tariff_exists: "Tarife mevcut değil!",
  qr_upgraded_successfully: "QR'niz başarıyla yükseltildi.",
  check_account_balance: "Hesap bakiyenizi kontrol edin ve daha sonra deneyin.",
  group_renewal_price_error: "Toplu yenileme fiyatı alma hatası!",
  qr_count_error: "QR sayısı alma hatası!",
  no_qr_for_renewal: "Yenilenecek QR yok!",
  table_pagination: "Tablo sayfalandırma",
  virtual_scroll_display: "Sanal kaydırma görünümü",
  popups_shared_components: "Açılır pencereler ve ortak bileşenler",
  edit_qr_address: "QR adresini düzenle",
  please_enter_correct_address: "Lütfen doğru adres girin",
  successfully_edited: "Başarıyla düzenlendi.",
  error_editing_qr_address: "QR adresi düzenleme hatası!",
  go_to_page: "Sayfaya git",
  page_from_to: "Sayfa {current} / {last}",
  display: "Görüntüle",
  to: "ile",
  from: "arasında",
  show: "Göster",
  page_status: "Sayfa {current} / {total}",
  until: "kadar",
  successfully_completed: "Başarıyla tamamlandı",
  problem_occurred: "Bir sorun oluştu",
  download_failed: "İndirme başarısız",
  audio_file_default: "Ses dosyası",
  memory_release: "Bellek boşaltma",
  seek_music_comment: "Örneğin, bu müzik veya bir şey arayan",
  all: "Tümü",
  create_podcast: "Podcast oluştur",
  add_link: "Bağlantı ekle",
  upload_file: "Dosya yükle",
  file_list: "Dosya listesi",
  count: "Sayı",
  select_category: "Kategori seç",
  after_typing_enter: "Yazdıktan sonra Enter tuşuna basın.",
  no_image_available: "Görsel mevcut değil",
  no_image_found: "Görsel bulunamadı!",
  for_adding_file_use_upload_center:
    "Dosya eklemek için yükleme alanı veya yükleme merkezini kullanın",
  ai_story_creation_description: "Hikayenizi girin, AI sizin için oluşturacak",
  create_new_podcast: "Yeni podcast oluştur",
  show_audio_file: "Ses dosyasını göster",
  cancel: "İptal",
  no_audio_in_category: "Bu kategoride ses dosyası yok",
  health_apple: "Sağlık Elması",
  standard: "Standart",
  arshia_badge: "Arşiya Rozeti",
  home_appliances_association: "Ev Aletleri Derneği",
  energy_label: "Enerji Etiketi",
  select_gold_purity_first: "Fiyat almak için önce altın saflığını seçin",
  gold_price_service: "Altın Fiyat Servisi",
  rahvard: "Rehber",
  to_change_gold_service_go_to_assets:
    "Altın fiyat servisini değiştirmek için varlıklara gidin",
  gold: "Altın",
  purity: "Saflık",
  rial: "Riyal",
  final_product_price: "Nihai ürün fiyatı",
  show_images_right_side: "Görselleri sağ tarafta göster",
  show_as_slider: "Kaydırıcı olarak göster",
  show_as_grid: "Izgara olarak göster",
  show_as_second_mode: "İkinci mod olarak göster",
  gallery_name: "Galeri adı",
  change_gallery_name: "Galeri adını değiştir",
  add_photo: "Fotoğraf ekle",
  select_photo: "Fotoğraf seç",
  show_image: "Görseli göster",
  selected_photo: "Seçilen fotoğraf",
  to_use_ready_images_search_category_or_product:
    "Hazır görselleri kullanmak için yukarıda kategori veya ürün arayın.",
  max_file_size_2mb: "Maksimum dosya boyutu: 2 MB.",
  drag_and_drop_to_upload_or: "Yüklemek için sürükleyip bırakın veya",
  here: "buraya",
  click: "tıklayın",
  to_use_external_image_link_fill_fields:
    "Harici görsel bağlantısı kullanmak için aşağıdaki alanları doldurun",
  image_url_hint: "İstenen görsel URL'si (bağlantı).",
  image_url: "Görsel bağlantısı",
  add_new_gallery: "Yeni galeri ekle",
  create_image: "Görsel oluştur",
  ready_images: "Hazır görseller",
  edit_image: "Görseli düzenle",
  enter_valid_link: "Geçerli bir bağlantı girin.",
  max_background_image_size_2mb: "Maksimum arka plan görsel boyutu: 2 MB.",
  uploaded_successfully: "Başarıyla yüklendi.",
  banner: "Afiş",
  question: "Soru",
  selected_question: "Seçilen soru",
  answer: "Cevap",
  add_question: "Soru ekle",
  selected_blog: "Seçilen blog",
  icon: "Simge",
  select_icon: "Simge seç",
  add_blog: "Blog ekle",
  post: "Gönderi",
  selected_services: "Seçilen hizmetler",
  add_new_post: "Yeni gönderi ekle",
  add_new_services: "Yeni hizmetler ekle",
  add_new_service: "Yeni hizmet ekle",
  domain_must_be_https_or_http:
    "Alan adı https://terminalads.com veya terminalads.com olmalıdır.",
  id: "ID",
  images: "Görseller",
  tags: "Etiketler",
  print_type: "Baskı türü",
  user: "Kullanıcı",
  user_shipping_info: "Kullanıcı kargo bilgileri",
  qr_short_link: "QR kısa bağlantı",
  delivery_method: "Teslimat yöntemi",
  delivery_at_company: "Şirkette teslimat",
  delivery_by_post: "Posta ile teslimat",
  post_cost_and_tax_warning:
    "Kayıt sırasında posta masrafları ve %10 vergi cüzdanınızdan düşülecek.",
  shipping_info: "Kargo bilgileri",
  continue_shopping: "Alışverişe devam et",
  complete_shopping: "Alışverişi tamamla",
  select_free_nfc_card: "Ücretsiz NFC kart seç",
  order_custom_nfc_card: "Özel NFC kart sipariş et",
  buy_qr_equipment: "QR ekipmanı satın al",
  vertical: "Dikey",
  horizontal: "Yatay",
  card_type: "Kart türü",
  tag: "Etiket",
  select: "Seç",
  order_card: "Kart sipariş et",
  available: "Mevcut",
  unavailable: "Mevcut değil",
  for_initial_loading: "İlk yükleme için",
  already_have_free_nfc_message:
    "Bu QR için zaten ücretsiz NFC aldınız. Değiştirmek için özel kart satın alın.",
  nfc_in_delivery_process_message:
    "Zaten ücretsiz NFC kaydettiniz, yolda. Değiştirmek için özel kart satın alın.",
  free_nfc_card_warning_message:
    "Sayın kullanıcı: Ücretsiz NFC kartlar önceden basılmıştır, QR'niz değişir. Kullanıldıysa özel kart satın alın.",
  select_card: "Kart seç",
  free_card_selection_conditions: "Ücretsiz kart seçim koşulları",
  confirm_and_select: "Onayla ve seç",
  registered_successfully: "Başarıyla kaydedildi.",
  error_registering_nfc_order: "NFC kart siparişi kayıt hatası!",
  nfc_physical_card_orders: "Fiziksel NFC kart siparişleri",
  buy_equipment: "Ekipman satın al",
  select_quantity: "Miktar seç",
  ready_samples: "Hazır örnekler",
  upload_custom_design: "Özel tasarım yükle",
  select_ready_card_image: "Hazır kart görseli seç",
  select_card_front_image: "Kart ön yüz görseli seç",
  select_card_back_image: "Kart arka yüz görseli seç",
  nfc_card_image: "NFC kart görseli",
  add_quantity: "Miktar ekle",
  total_price: "Toplam fiyat",
  price_with_discount: "İndirimli fiyat",
  shipping_cost: "Kargo ücreti",
  your_profit_from_purchase: "Satın alımdan karınız",
  discount: "İndirim",
  ten_percent_tax_will_be_added: "Nihai tutara %10 vergi eklenecek.",
  payable_amount: "Ödenecek tutar",
  continue: "Devam et",
  Confirm_code: "Onay kodu",
  form_success_message: "Formunuz başarıyla gönderildi",
  refill_form_message: "Lütfen formu yeniden doldurun",
  Enter_the_sent_code: "Size gönderilen kodu girin",
  SUBMIT_FORM: "Formu gönder",
  enter_phone_number: "Cep telefonu numaranızı girin",
  order_registered_successfully: "Siparişiniz başarıyla kaydedildi.",
  smart_creation: "Akıllı oluşturma",
  automatic_creation: "Otomatik oluşturma",
  business_name: "İşletme adı",
  example_household_goods: "Örnek: ev eşyaları",
  organization_name: "Kurum adı",
  example_tech_company: "Örnek: ileri teknoloji şirketi",
  minimum_two_characters_required: "En az iki karakter gerekli!",
  maximum_100_characters_allowed: "Maksimum 100 karakter",
  latin_name_qr_address: "Latince ad (QR adresi)",
  example_advanced_tech: "Örnek: advanced-tech",
  only_english_numbers_dash_allowed:
    "Sadece İngilizce harf, rakam ve tire izin verilir",
  maximum_50_characters_allowed: "Maksimum 50 karakter",
  latin_name_goes_after_domain: "Latince ad alan adından sonra gelir",
  select_logo_and_store_product_image: "Logo ve mağaza/ürün görseli seç",
  select_logo: "Logo seç",
  file_size_must_be_less_than_2mb: "Dosya boyutu 2 MB'den küçük olmalı",
  for_buying_renewing_qr_click_expiry_button:
    "QR satın almak/yenilemek için son kullanma tarihine tıklayın.",
  for_group_renewal_select_desired_qr_codes:
    "Toplu yenileme için istediğiniz QR kodlarını seçin.",
  no_qr_found_with_these_filters: "Bu filtrelerle QR bulunamadı!",
  i_buy: "Satın alıyorum",
  visits: "Ziyaretler",
  creation_time: "Oluşturma zamanı",
  edit_time: "Düzenleme zamanı",
  enter_business_card_name_correctly: "Kartvizit adını doğru girin!",
  are_you_sure_delete_qr: "QR'yi silmek istediğinizden emin misiniz?",
  qr_deleted_successfully: "QR başarıyla silindi.",
  are_you_sure_deactivate_qr:
    "QR'yi devre dışı bırakmak istediğinizden emin misiniz?",
  are_you_sure_activate_qr: "QR'yi etkinleştirmek istediğinizden emin misiniz?",
  deactivated: "Devre dışı",
  qr_successfully: "QR başarıyla",
  successfully: "Başarıyla",
  user_transferred_successfully: "Kullanıcı başarıyla transfer edildi",
  problem_occurred_in_transfer: "Transferde sorun oluştu!",
  error_in_user_transfer: "Kullanıcı transfer hatası!",
  qr_business_card_edited_successfully: "Kartvizitiniz başarıyla düzenlendi.",
  group_qr_renewal: "Toplu QR yenileme",
  select_desired_duration: "İstediğiniz süreyi seçin",
  total_count: "Toplam sayı",
  final_amount: "Nihai tutar",
  ten_percent_vat_will_be_added: "Yukarıdaki tutara %10 KDV eklenecek.",
  pay_and_upgrade: "Öde ve yükselt",
  no_tariff_for_this_period: "Bu dönem için tarife yok!",
  selected: "Seçildi",
  total_amount: "Toplam tutar",
  final_amount_with_discount: "İndirimli nihai tutar",
  add_qr: "QR ekle",
  actions: "Eylemler",
  filter_type: "Tür filtresi",
  start_from: "Başlangıç",
  search_in_id: "ID'de ara",
  filter_user: "Kullanıcı filtresi",
  clear_filters: "Filtreleri temizle",
  send_sms: "SMS gönder",
  selected_pattern: "Seçilen şablon",
  send: "Gönder",
  bulk_download: "Toplu indirme",
  one_month_renewal: "Bir aylık yenileme",
  three_month_renewal: "Üç aylık yenileme",
  six_month_renewal: "Altı aylık yenileme",
  one_year_renewal: "Bir yıllık yenileme",
  no_item_selected: "Öğe seçilmedi!",
  error_loading_card_info: "Kart bilgisi yükleme hatası!",
  send_registered_successfully: "Gönderim başarıyla kaydedildi",
  error_getting_prices: "Fiyat alma hatası!",
  payment_error: "Ödeme hatası!",
  business_card: "Kartvizit",
  product_label: "Ürün etiketi",
  restaurant_menu: "Restoran menüsü",
  event_ticket: "Etkinlik bileti",
  brochure: "Broşür",
  flyer: "El ilanı",
  poster: "Afiş",
  catalog: "Katalog",
  newsletter: "Bülten",
  organization_name_hint: "Kurum adınızı girin.",
  organization_name_label: "Kurum adı",
  sub_organization_hint: "Alt kurum adını girin.",
  sub_organization_label: "Alt kurum açıklaması",
  user_name_hint: "Adınızı girin.",
  user_name_label: "Ad ve soyad",
  work_field_hint: "Görev unvanınızı girin.",
  work_field_label: "Görev",
  mobile_number_hint: "Numaranızı girin.",
  mobile_number_label: "Cep telefonu",
  phone_number_hint: "Telefon numarasını girin.",
  phone_number_label: "Telefon numarası",
  email_hint: "E-postanızı girin.",
  email_label: "E-posta",
  fax_hint: "Şirket faksını girin.",
  fax_label: "Şirket faksı",
  website_hint: "Şirket web sitesini girin.",
  website_label: "Şirket web sitesi",
  postal_code_hint: "Posta kodunu girin.",
  postal_code_label: "Posta kodu",
  copyright_hint: "Altbilgideki telif hakkı metnini girin.",
  copyright_label: "Telif hakkı metni",
  address_hint: "Adresinizi girin.",
  address_label: "Adres",
  add_more_info: "İstediğiniz ek bilgileri ekleyin:",
  edit_location: "Düzenle",
  add_location: "Ekle",
  delete_location: "Konumu sil",
  about_us_label: "Hakkımızda",
  search_address: "Adres ara:",
  northern_coordinates: "Kuzey koordinatları",
  eastern_coordinates: "Doğu koordinatları",
  select_address_on_map: "Haritada adres seç",
  location_not_found: "Konum bulunamadı.",
  text_label: "Metin",
  number_label: "Sayı",
  website_address_label: "Web sitesi adresi",
  location_label: "Konum",
  mobile_viewer_title: "Mobil Görüntüleyici",
  visit_theme_two_title: "Kartvizit Teması 2",
  visit_theme_flipped_title: "Ters Çevrilmiş Kartvizit Teması",
  flip_card: "Kartı çevir",
  flip_card_description: "Daha fazla bilgi için kartı çevirin",
  share_contacts: "Kişileri paylaş",
  close_share: "Paylaşımı kapat",
  card_front: "Kart ön yüzü",
  card_back: "Kart arka yüzü",
  flip_to_back: "Arkaya çevir",
  flip_to_front: "Öne çevir",
  swipe_to_flip: "Çevirmek için kaydırın",
  swipe_left: "Sola kaydır",
  swipe_right: "Sağa kaydır",
  expand_card: "Kartı genişlet",
  contract_card: "Kartı daralt",
  view_details: "Detayları görüntüle",
  hide_details: "Detayları gizle",
  social_media_share: "Sosyal medya paylaşımı",
  contact_actions: "İletişim eylemleri",
  card_actions: "Kart eylemleri",
  floating_menu: "Kayan menü",
  close_menu: "Menüyü kapat",
  open_menu: "Menüyü aç",
  choice_gallery: "Seçilen galeri",
  choice_video: "Video seç",
  url_video: "Video bağlantısı",
  selected_video: "Seçilen video",
  add_video: "Video ekle",
  edit_video: "Videoyu düzenle",
  linl_video: "Yayın bağlantısı",
  upload_video: "Video yükle",
  rule_link: "Alan adı https://terminalads.com veya terminalads.com olmalıdır.",
  fax_hint: "Şirket faksını girin.",
  fax_label: "Şirket faksı",
  website_hint: "Şirket web sitesini girin.",
  website_label: "Şirket web sitesi",
  postal_code_hint: "Posta kodunu girin.",
  postal_code_label: "Posta kodu",
  add_more_info: "İstediğiniz ek bilgileri ekleyin:",
  address_hint: "Adresinizi girin.",
  address_label: "Adres",
  edit_location: "Düzenle",
  add_location: "Ekle",
  delete_location: "Konumu sil",
  location_label: "Konum",
  about_company_label: "Şirket hakkında",
  select_address_on_map: "Haritada adres seç",
  search_address: "Adres ara:",
  rule_link: "Alan adı https://terminalads.com veya terminalads.com olmalıdır.",
  link_label: "Bağlantı adresi",
  label_label: "Etiket",
  field_value_label: "Alan değeri",
  add_new_field: "Yeni alan ekle",
  tehran_address:
    "Tahran, Şariati Caddesi, Seyyid Handan Köprüsü sonrası, Handan Sokağı, No 6",
  welcome_message_hint:
    "Etkinse, müşteriniz kulübünüze katıldığında hoş geldin mesajı gönderilir.",
  change_pattern_campaign: "Şablon/kampanya değiştir",
  selected_message: "Seçilen mesaj:",
  required_inputs: "Zorunlu alanlar:",
  selected_campaign_or_pattern: "Seçilen kampanya/şablon:",
  campaign: "Kampanya",
  pattern: "Şablon",
  id: "ID",
  auto_csv_download_label: "Otomatik kaydetme",
  auto_csv_download_hint:
    "Kart açıldığında bilgileriniz otomatik olarak müşterinin telefonuna indirilir.",
  show_cclub_onload_label: "Üyelik teklifi",
  show_cclub_onload_hint: "Müşteri kulübüne katılma penceresi açılır.",
  forced_submission_hint:
    "Üyelik formu gösterildiğinde müşteri numarasını kaydetmek zorundadır.",
  forced_submission_forced: "Zorunlu üyelik",
  forced_submission_optional: "İsteğe bağlı üyelik",
  has_manifest_icons_label: "Web uygulaması ayarı",
  has_assistant_label: "Asistan Etiketi",
  select_assistant: "Asistan Seç",
  assistant_ai: "Yapay Zeka Asistanı",
  has_manifest_icons_hint:
    "Logo ve görsel, web uygulaması telefona veya bilgisayara yüklendiğinde görünür.",
  logo_144px: "Logo 144 px",
  logo_48px: "Logo 48 px",
  photo_wide: "Geniş fotoğraf",
  photo: "Fotoğraf",
  iranian_social_networks: "İran sosyal ağları",
  foreign_social_networks: "Yabancı sosyal ağlar",
  advertising_sites: "Reklam siteleri",
  other_links: "Diğer bağlantılar",
  custom_text: "Özel metin",
  custom_text_placeholder: "Özel metninizi girin.",
  aparat: "Aparat",
  aparat_hint: "Aparat kanal adınızı girin",
  eitaa: "Eitaa",
  eitaa_hint: "Kullanıcı adınızı girin",
  soroush: "Soroush",
  soroush_hint: "Kullanıcı adınızı girin",
  bale: "Bale",
  bale_hint: "Kullanıcı adınızı girin",
  rubika: "Rubika",
  rubika_hint: "Kanal/grup bağlantısını girin",
  gap: "Gap",
  gap_hint: "Kullanıcı adınızı girin",
  linkedin: "LinkedIn Kişisel Profil",
  linkedin_hint: "Kullanıcı adınızı girin",
  linkedin_company: "LinkedIn Şirket Sayfası",
  linkedin_company_hint: "Şirket sayfanızın adını girin",
  pinterest: "Pinterest",
  pinterest_hint: "Kullanıcı adınızı girin",
  dribbble: "Dribbble",
  dribbble_hint: "Kullanıcı adınızı girin",
  facebook: "Facebook",
  facebook_hint: "Kullanıcı adınızı girin",
  github: "GitHub",
  github_hint: "Kullanıcı adınızı girin",
  threads: "Threads",
  threads_hint: "Kullanıcı adınızı girin",
  tiktok: "TikTok",
  tiktok_hint: "Kullanıcı adınızı girin",
  twitter: "Twitter",
  twitter_hint: "Kullanıcı adınızı girin",
  skype: "Skype",
  skype_hint: "Kullanıcı adınızı girin",
  youtube: "YouTube",
  youtube_hint: "@ olmadan kullanıcı adınızı girin",
  wechat: "WeChat",
  wechat_hint: "Kullanıcı adınızı girin",
  viber: "Viber",
  viber_hint: "Kullanıcı adınızı girin",
  divar: "Divar",
  divar_hint: "İlan/dükkan/mağaza bağlantısını girin",
  sheypoor: "Sheypoor",
  sheypoor_hint: "İlan/dükkan/mağaza bağlantısını girin",
  social_network: "Sosyal ağ",
  photo_logo_tab: "Görsel/Logo",
  gallery_image_tab: "Görsel Galerisi",
  template_image: "Şablon Görseli",
  background_image: "Arka Plan Görseli",
  upload_logo: "Logo yükle",
  welcome_image_upload: "Hoş geldin görseli/logo yükle",
  welcome_photo: "Hoş geldin fotoğrafı",
  loading_animation: "Yükleme Animasyonu",
  preview_welcome_page: "Hoş geldin sayfası önizleme",
  default_template_image: "Varsayılan şablon arka plan görseli",
  default_background_image: "Varsayılan arka plan görseli",
  default_logo: "Varsayılan logo",
  default_welcome: "Varsayılan hoş geldin",
  default_gallery: "Varsayılan galeri",
  animation_scale: "Merkezden ölçekle",
  animation_slide_x: "Soldan kaydır",
  animation_slide_y: "Yukarıdan kaydır",
  animation_fade: "Soldurma",
  image_size_error: "Maksimum arka plan görsel boyutu: 2 MB.",
  logo_size_error: "Maksimum logo boyutu: 2 MB.",
  categories: {
    bankcard: 'Banka Kartı',
    bale: "Bale",
    robika: "Robika",
    eitaa: "Eitaa",
    text: "Metin",
    multi_card: "Çoklu Kart",
    product_introduction_pro: "Ürün Tanıtımı Pro",
    "gift": "Hediye",
    electronic_business_card_pro: "Pro Elektronik Kartvizit",
    link_pro:"Link Pro",
    generated_images: "Oluşturulan görseller",
    electronic_business_card: "Elektronik kartvizit",
    social_media: "Sosyal medya",
    photo_gallery: "Fotoğraf galerisi",
    video_gallery: "Video galerisi",
    link: "Bağlantı",
    audio_gallery: "Ses galerisi",
    audio_gallery_pro: "Ses galerisi (Pro)",
    feedback: "Geri bildirim",
    consultation_form: "Danışma formu",
    application: "Uygulama",
    pdf_gallery: "PDF galerisi",
    schedule_table: "Zaman çizelgesi tablosu",
    personal_company_website: "Kişisel/şirket web sitesi",
    online_store: "Online mağaza",
    online_menu: "Online menü",
    appointment_booking: "Randevu rezervasyonu",
    commercial_admin_website: "Ticari/yönetim web sitesi",
    online_insurance_sales: "Online sigorta satışları",
    discount_code: "İndirim kodu",
    product_introduction: "Ürün tanıtımı",
    product_label: "Ürün etiketi",
    gold_label: "Altın etiketi",
    franchise: "Franchise (iş sayfası)",
    marketplace: "Pazar yeri (iş sayfası)",
    recruitment_form: "İşe alım formu",
    organizational_form: "Kurumsal form",
    employee_card: "Çalışan kartı",
    book_magazine: "Kitap/dergi",
    catalog_brochure: "Katalog/broşür",
    catalog: "Katalog",
    faq: "SSS",
    feedback_survey: "Geri bildirim/anket",
    consultation_request: "Danışma talebi",
    customer_club: "Müşteri kulübü",
    invitation_card: "Davetiye kartı",
    countdown: "Geri sayım",
    tombstone: "Mezar taşı",
  },
  support_day60: "60 gün para iade garantisi",
  "enter_visit_card_pro_info": "Pro Kartvizit adını girin",

  ROUTE: {
    TITLES: {
      QR_NAME_EDIT_TEXT: "QR metnini düzenle",
       SERVER_DOWN: "Güncelleniyor",
    CREATE_MEMORIES_MODEL: "Anı Çerçevesi Şablonu Oluştur",
    CREATE_CARD_VISIT_PRO_MODEL: "Kartvizit Pro Şablonu Oluştur",
    CREATE_PRODUCT_PRO_MODEL: "Ürün Tanıtım Pro Şablonu Oluştur",
    CREATE_PRODUCT_LABEL_MODEL: "Ürün Etiketi Şablonu Oluştur",
    CREATE_PHOTO_GALLERY_MODEL: "Fotoğraf Galerisi Şablonu Oluştur",
    CREATE_PDF_GALLERY_MODEL: "PDF Galerisi Şablonu Oluştur",
    CREATE_SOCIAL_MEDIA_MODEL: "Sosyal Medya Şablonu Oluştur",
    EDIT_CARD_VISIT_PRO_MODEL: "Kartvizit Pro Şablonunu Düzenle",
    EDIT_PRODUCT_PRO_MODEL: "Ürün Tanıtım Pro Şablonunu Düzenle",
    EDIT_PRODUCT_LABEL_MODEL: "Ürün Etiketi Şablonunu Düzenle",
    EDIT_PHOTO_GALLERY_MODEL: "Fotoğraf Galerisi Şablonunu Düzenle",
    EDIT_PDF_GALLERY_MODEL: "PDF Galerisi Şablonunu Düzenle",
    EDIT_SOCIAL_MEDIA_MODEL: "Sosyal Medya Şablonunu Düzenle",
    BOOK: "Kitap",
    NFC_LIST: "NFC Listesi",
    API_KEY_MANAGER: "API Anahtarı Oluştur",
    PRE_PURCHASE: "Ön Satın Alma",
    PRE_PURCHASE_MODEL: "Hazır Şablon",
      "QR_NAME_EDIT_GIFT": "Hediye QR Kodunu Düzenle",
      "QR_GIFT": "Hediye QR Kodu",
      "QR_NAME_EDIT_PRO": "Pro Bağlantı QR Kodunu Düzenle",
      "QR_LINK_PRO": "QR Link Pro",
      DIGI: "Digikala Fiyat İzleme",
      QR_PDF: "PDF Galerisi",
      QR_NAME_EDIT_PDF: "PDF Galerisini Düzenle",
      QR_MULTICART: "QR Çoklu Kart",
      QR_MULTICART_EDIT: "QR Çoklu Kartı Düzenle",
      QR_NAME_PRODUCTPRO: "Ürün Pro Tanıtımını Düzenle",
      QR_PRODUCTPRO: "Ürün Pro Tanıtımı",
      QR_CATALOG: "Katalog / Broşür",
      QR_NAME_EDIT_CATALOG: "Kataloğu Düzenle",
      QR_LUCK_WHEEL_Edit: "Şans Çarkını Düzenle",
      QR_LUCK_WHEEL: "Şans Çarkı QR Kodu Oluştur",
      DASHBOARD: "Kontrol Paneli",
      ADMIN_QR_DOMAINS: "Alan Adı İzleme",
      ADMIN_TOGETHER_TOKEN: "Token İzleme",
      ADMIN_QR_SMS: "SMS Gönderimi",
      MENU_PROFILE_INFO: "Kullanıcı Bilgileri",
      MENU_PROFILE_SETTING: "Profil Ayarları",
      MENU_PROFILE_ORDERS: "Siparişler",
      MENU_PROFILE_ADDRESSES: "Adresler",
      QR_MONITORING: "QR İzleme",
      QR_LIST: "QR Listem",
      QR_NAME_LIST: "Katılım Yönetimi",
      QR_GENERATE_MULTIPLE: "Toplu QR Kodu Oluşturma",
      QR_CARD_VISIT: "Kartvizit Oluştur",
      HELP_INFO: "Düğmeyi Test Et",
      QR_MENU: "Mağaza Menüsü",
      QR_APPOINTMENT: "Randevu Alma",
      QR_INSURANCE: "Çevrimiçi Sigorta Oluştur",
      QR_BPAGE: "İş Sayfası Oluştur",
      QR_CPAGE: "Ticari/İdari Kompleks Sitesi Oluştur",
      QR_BSHOP: "Çevrimiçi Mağaza",
      QR_NAME_EDIT_BSHOP: "Çevrimiçi Mağazayı Düzenle",
      QR_LINK_EDIT: "Bağlantıyı Düzenle",
      QR_NAME_DESIGN: "Tasarımı Düzenle",
      QR_NAME_SETTING: "Ayarları Düzenle",
      QR_NAME_EDIT: "Kartviziti Düzenle",
      QR_NAME_EDIT_BPAGE: "İş Sayfasını Düzenle",
      QR_EDIT_CPAGE: "Ticari/İdari Kompleks Sitesini Düzenle",
      QR_NAME_INSURANCE: "Çevrimiçi Sigortayı Düzenle",
      QR_NAME_EDIT_MENU: "Menüyü Düzenle",
      QR_NAME_EDIT_APPLICATION: "Uygulamayı Sağla",
      QR_NAME_EDIT_APPOINTMENT: "Randevu Almayı Düzenle",
      QR_NAME_EDIT_PHOTO: "Fotoğraf Galerisini Düzenle",
      QR_NAME_EDIT_VIDEO: "Video Galerisini Düzenle",
      QR_NAME_EDIT_VOICE: "Ses Galerisini Düzenle",
      QR_NAME_EDIT_FEEDBACK: "Geri Bildirim Galerisini Düzenle",
      QR_NAME_CONSULTATION_QR_EDIT: "Talep Formunu Düzenle",
      QR_NAME_EDIT_VOICE_PRO: "Ses Galerisini Düzenle (Pro)",
      QR_NAME_EDIT_SOCIAL: "Sosyal Ağları Düzenle",
      QR_NAME_STATISTICS: "QR Kodu İstatistikleri",
      QR_CATE: "Kategori Seç",
      QR_SHARE: "Paylaş",
      QR_BUSINESS_SHOP: "İşletme/Mağaza",
      QR_CO_ORGAN: "Şirket/Kuruluş",
      QR_CONTACT: "Müşteri İletişimi",
      QR_NOTICES: "Bildirimler",
      QR_OTHERS: "Diğer",
      QR_STATICS: "Statik QR",
      QR_DYNAMICS: "Dinamik QR",
      QR_D_BUSINESS: "Dinamik İş QR",
      QR_D_ORGANS: "Dinamik Kuruluş QR",
      QR_D_GOVERNMENT: "Dinamik Devlet QR",
      QR_VIDEO: "Video Galerisi",
      QR_APPLICATION: "Uygulamayı Sağla",
      QR_VOICE: "Ses Galerisi",
      QR_VOICE_PRO: "Ses Galerisi (Pro)",
      QR_CONSULTATION_QR: "Talep Formu",
      QR_FEEDBACK: "Geri Bildirim Galerisi",
      QR_PHOTO: "Fotoğraf Galerisi",
      QR_LOCATION: "Konum QR Oluştur",
      QR_SOCIAL_MEDIA: "Sosyal Medya QR Oluştur",
      QR_LINK: "Bağlantı Oluştur",
      QR_TEXT: "Metin Oluştur",
      QR_MAIL: "E-posta Oluştur",
      QR_CALL: "Arama",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Web Sitesi",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "İş Sayfası",
      QR_DISCOUNT: "İndirim Sayfası",
      QR_PRODUCT_SHOP: "Ürün Tanıtımı",
      QR_PRODUCT_LABEL: "Ürün Etiketi",
      QR_GOLD_LABEL: "Altın Etiket",
      QR_PRODUCT_TEMPLATE: "Ürünler",
      ADMIN_CATEGORY: "Kategoriler",
      QR_NFC_ORDERS: "Onay Bekleyen NFC Kartlar",
      QR_NAME_PRODUCT: "Ürün Tanıtımını Düzenle",
      QR_NAME_LABELPRODUCT: "Ürün Etiketini Düzenle",
      QR_NAME_GOLDPRODUCT: "Altın Etiketi Düzenle",
      QR_COINS: "Kripto Paralar",
      QR_SHOP: "Mağaza Yönetimi",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Yükleme Merkezi",
      PRICING: "QR Tarifeleri",
      QR_CREATE_MODELS: "Kartvizit Modeli Oluştur",
      QR_CREATE_BUSINESS_MODELS: "İş Sayfası Modeli Oluştur",
      QR_CREATE_PRODUCT_MODEL: "Ürün Kartı Modeli Oluştur",
      QR_CREATE_MENU_MODELS: "Mağaza Menüsü Modeli Oluştur",
      QR_CREATE_SHOP_MODEL: "Çevrimiçi Mağaza Modeli Oluştur",
      MODELS_LIST: "QR Model Türleri",
      MODELS_LIST_EDIT: "Modeli Düzenle",
      MODELS_LIST_MENU_EDIT: "Menü Modelini Düzenle",
      MODELS_LIST_BMODEL_EDIT: "Çevrimiçi Mağaza Modelini Düzenle",
      NFC: "NFC Kartlar",
      SUBMIT_FORM: "Blogcu Kaydet",
      REQUEST_LIST: "Blogcu Listesi",
      PURE_DATA: "Oluşturulmamış Kartvizit Listesi",
      AUTO_CREATE: "Otomatik QR Oluşturma",
      QR_CREATE: "QR Oluştur",
      HISTORY_REMINDER: "Hatırlatma İzleme",
      BOOK: "Hatırlatma İzleme"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "Ödeme Yöntemleri",
      ORDER_NOTIFICATIONS: "Sipariş Bildirimleri",
      DISCOUNT_CODE: "İndirim Kodu",
      CART: "Alışveriş Sepeti",
      TABLE_MANAGEMENT: "Masa Yönetimi",
    },
    ERRORS: {
      INVALID_INPUT: "Lütfen değerleri doğru girin!",
      CART_SETTINGS_FAILED: "Alışveriş sepeti ayarları başarısız oldu!",
    },
  },
  popup: {
    prepared_stores_title: "Hazır Çevrimiçi Mağaza Örnekleri",
  },
  buttons: {
    reset_defaults: "Varsayılan verileri sıfırla",
    download_qr: "QR İndir",
    cleardefaults: "Varsayılan bilgileri temizle",
    select_prepared_store: "Hazır çevrimiçi mağaza seç",
  },
  stepper: {
    create_qr: "QR Oluştur",
    products_info: "Ürünler ve Bilgiler",
    content_settings: "İçerik Ayarları",
    sales_settings: "Satış Ayarları",
  },
  fields: {
    online_store_name: "Çevrimiçi Mağaza Adı",
    qr_address: "QR Adresi",
    qr_address_hint: "QR adresinizi girin",
    online_sale: "Çevrimiçi Satış",
  },
  login_settings: "Giriş Ayarları",
  shop_logo_and_images: "Mağaza Logosu ve Görselleri",
  login_page_info: "Giriş Sayfası Bilgileri",
  upload_banner: "Banner Yükle",
  create_product: "Ürün Oluştur",
  special_sale: "Özel Satış",
  ended: "Bitti",
  blog: "Blog",
  services: "Hizmetler",
  pdf_gallery: "PDF Galerisi",
  create_section: "Bölüm Oluştur",
  achievements: "Başarılar",
  team_members: "Ekip Üyeleri",
  working_hours: "Çalışma Saatleri",
  saturday: "Cumartesi",
  sunday: "Pazar",
  monday: "Pazartesi",
  tuesday: "Salı",
  wednesday: "Çarşamba",
  thursday: "Perşembe",
  friday: "Cuma",
  we_will_be_different: "Farklı olacağız...",
  striving_for_excellence:
    "Her zaman en iyisi olmaya çalışıyoruz >>> sizin için",
  online_store_ready_15_minutes: "Çevrimiçi mağazanız 15 dakikada hazır!",
  sales_management: "Satış Yönetimi",
  dear_customer_online_stores:
    "Sevgili müşteri, diğer çevrimiçi mağazalarımızdan da alışveriş yapabilirsiniz:",
  divar_site: "Divar Sitesi",
  digikala_site: "Digikala Sitesi",
  basalam_site: "Basalam Sitesi",
  torob_site: "Torob Sitesi",
  emalls_site: "Emalls Sitesi",
  copyright_qrland: "Tüm hakları QR Land'e aittir.",
  tehran_address:
    "Tahran, Şeriati Caddesi, Seyed Handan Köprüsü sonrası, Handan Sokağı, No. 6",
  our_achievements: "Koleksiyonumuzun başarıları",
  customer_satisfaction: "Müşteri Memnuniyeti",
  lowest_returns: "En Düşük İadeler",
  loyal_customer: "Sadık Müşteri",
  shipped_orders: "Gönderilen Siparişler",
  visit_our_videos: "Koleksiyonumuzun videolarını ziyaret edin.",
  bringing_the_best: "Size en iyisini getirdik...",
  feedback_important: "Geri bildiriminiz bizim için önemli",
  guide_us_with_feedback:
    "Aşağıdaki soruları yanıtlayarak daha iyi hizmet vermemize rehberlik edin.",
  satisfied_with_quality: "Ürünlerin kalitesinden memnun musunuz?",
  evaluate_packaging_quality: "Ambalaj kalitesini nasıl değerlendiriyorsunuz?",
  satisfied_with_variety: "Ürün çeşitliliğinden memnun musunuz?",
  benefited_from_discounts: "Bu mağazanın indirimlerinden yararlandınız mı?",
  post_1: "Gönderi 1",
  fast_order_delivery: "Hızlı Sipariş Teslimatı",
  post_2: "Gönderi 2",
  post_3: "Gönderi 3",
  product_authenticity_guarantee: "Ürün Orijinallik Garantisi",
  comfortable_purchase: "Konforlu alışveriş",
  how_to_place_order: "Siparişimi nasıl verebilirim?",
  add_to_cart: "İstediğiniz ürünleri alışveriş sepetine ekleyin.",
  how_to_register: "Siteye nasıl kayıt olabilirim?",
  click_login_and_enter_code:
    "Giriş düğmesine tıklayın ve cep telefonu numaranızı girdikten sonra SMS kodunu girin.",
  delivery_time: "Kayıttan sonra siparişimin gelmesi ne kadar sürer?",
  fastest_delivery: "Siparişiniz mümkün olan en kısa sürede gönderilecektir.",
  shipping_cost: "Kargo ücreti nedir?",
  shipping_cost_order: "Sipariş Kargo Ücreti",
  variable_shipping_cost: "Kargo ücreti adresinize göre değişir.",
  change_or_cancel_order:
    "Sipariş verdikten sonra değiştirebilir veya iptal edebilir miyim?",
  no_change_or_cancel: "Hayır. Değişiklik veya iptal mümkün değildir.",
  mrs_Safdarian: "Bayan Safdarian",
  invalid_address: "Girilen adres geçersiz!",
  shop_page_created_success: "Mağaza sayfanız başarıyla oluşturuldu.",
  qr_creation_failed: "QR oluşturma başarısız oldu!",
  server_error: "Sunucu hatası!",
  qr_card_updated_success: "Kartvizitiniz başarıyla düzenlendi.",
  qr_save_edit_failed: "QR kaydetme/düzenleme hatası",
  your_feedback: "Geri bildiriminiz",
  digital_marketing_strategy:
    "Şirketinizi dijital pazarlama stratejistimizle doğru yola koyun",
  wait_for_default_products:
    "Lütfen varsayılan ürünler sitenize tamamen yüklenene kadar bekleyin.",
  template_categories_saved: "Örnek model kategorileri başarıyla kaydedildi.",
  template_products_saved: "Örnek model ürünleri başarıyla kaydedildi.",
  template_products_save_failed: "Örnek model ürünleri kaydetme hatası!",
  template_categories_save_failed: "Örnek model kategorileri kaydetme hatası!",
  login_page_text: "Giriş Sayfası Metni",
  persian_error: "Metin Farsça olmalıdır",
  number_error: "Girilen veriler sayısal olmayan veya boş olmamalıdır",
  english_error: "Metin İngilizce olmayan veya boş olmamalıdır",
  mixPerEng_error:
    "Metin İngilizce olmayan veya Farsça olmayan veya boş olmamalıdır",
  email_error: "Girilen e-posta formatı geçersiz",
  mobile_error: "Girilen numara formatı geçersiz",
  meliCode_error: "Girilen ulusal kod formatı geçersiz",
  site_error: "Girilen site formatı geçersiz",
  min_length_error: "Girilen değer {{min}}'den küçük olamaz",
  max_length_error: "Girilen değer {{max}}'den büyük olamaz",
  form_submitted_message: "Formunuz başarıyla gönderildi",
  required_fields_error: "Zorunlu değerler girilmedi",
  headphone_title: "Kulaklık",
  buy_button: "Satın Al",
  day: "gün",
  hour: "saat",
  minute: "dakika",
  second: "saniye",
  required_field_error: "{{fieldName}} zorunludur",
  submit_request_button: "Talep Gönder",
  request_submitted_success: "Talebiniz başarıyla kaydedildi",
  feedback_submitted_success: "Geri bildiriminiz başarıyla kaydedildi",
  description_required_label: "Açıklama (zorunlu)",
  description_optional_label: "Açıklama (isteğe bağlı)",
  description_hint:
    "Lütfen istediğiniz açıklamayı bu alana girin (en az 3 karakter)",
  footer: {
    position: "Taraf",
    contactUs: "Bize Ulaşın",
    aboutUs: "Hakkımızda",
    firstShift: "Birinci Vardiya",
    secondShift: "İkinci Vardiya",
    startTime: "Başlangıç Saati",
    endTime: "Bitiş Saati",
    features: "Özellikler",
    partners: "Ortaklar",
    affiliates: "Bağlı Programlar",
    panels: "Paneller",
    supportTicket: "Destek Talebi",
    inPersonServices: "Yüz Yüze Hizmetler",
    liveChat: "Canlı Sohbet",
    faq: "Sık Sorulan Sorular",
    add_secondshift: "İkinci Vardiya Ekle",
    firstDate: "Başlangıç Tarihi",
    endDate: "Bitiş Tarihi",
  },
  qr_management: "QR Yönetimi",
  restore_default_questions: "Varsayılan soruları geri yükle",
  delete_all: "Tümünü Sil",
  edit_question: "Soruyu Düzenle",
  move_up: "Yukarı Taşı",
  move_down: "Aşağı Taşı",
  delete: "Sil",
  selected_question: "Seçilen Soru",
  question: "Soru",
  answer_type: "Cevap Türü",
  excellent: "Mükemmel",
  good: "İyi",
  very_poor: "Çok Kötü",
  response_optionality: "İsteğe Bağlı / Zorunlu Cevap",
  required: "Zorunlu",
  optional: "İsteğe Bağlı",
  add_new_question: "Yeni Soru Ekle",
  satisfied_with_quality: "Ürünlerin kalitesinden memnun musunuz?",
  evaluate_packaging_quality: "Ambalaj kalitesini nasıl değerlendiriyorsunuz?",
  satisfied_with_variety: "Ürün çeşitliliğinden memnun musunuz?",
  benefited_from_discounts: "Bu mağazanın indirimlerinden yararlandınız mı?",
  suggestions_for_improvement:
    "Bu mağazada alışveriş deneyimini iyileştirmek için ne önerirsiniz?",
  confirm_delete_question: "Seçilen soruyu sil?",
  question_deleted_success: "Soru başarıyla silindi.",
  question_delete_failed: "Soru silme hatası!",
  confirm_delete_all_questions:
    "Tüm soruları silmek istediğinizden emin misiniz?",
  questions_deleted_success: "Sorular başarıyla silindi.",
  questions_delete_failed: "Soruları silme hatası!",
  invalid_input: "Lütfen değerleri doğru girin!",
  operation_failed: "İşlem başarısız oldu!",
  question_number: "Soru {number}?",
  card_subtitle:
    "İstediğiniz resmin hikayesini girin, yapay zeka sizin için oluştursun.",
  upgrade_label: "Ekle",
  free: " - Ücretsiz",
  language_select: "Talep metni yazmak için dil seç",
  image_size: "Resim Boyutu",
  prompt_label: "Talep Metni",
  prompt_placeholder: "İstediğiniz resmi tarif edin...",
  generate_image: "Resim Oluştur",
  regenerate_image: "Yeni Resim Oluştur",
  save_image: "Resmi Kaydet",
  save_image_subtitle: "Yalnızca yukarıda gösterilen resim kaydedilecek.",
  size_items: {
    "16:9": "16:9 (yatay)",
    "9:16": "9:16 (dikey)",
    "1:1": "1:1 (kare)",
  },
  lang_items: {
    fa: "Fa | Farsça",
    en: "En | İngilizce",
    ar: "Ar | Arapça",
  },
  rules: {
    empty: "En az 3 karakter girilmelidir!",
    spell_checker: "Girilen metin {language} dilinde olmalıdır!",
  },
  ERRORS: {
    VpnDetectedTitle: "VPN'inizi kapatın",
    VpnDetectedSubtitle:
      "Bu, sistemin daha iyi çalışmasına ve size daha iyi bir deneyim sunmasına yardımcı olur.",
  },
  errors: {
    VpnDetectedTitle: "VPN'inizi kapatın",
    VpnDetectedSubtitle:
      "Bu, sistemin daha iyi çalışmasına ve size daha iyi bir deneyim sunmasına yardımcı olur.",
    invalid_size: "Lütfen genişlik ve yüksekliği doğru girin!",
    image_generation_error: "Resim oluşturma hatası",
    image_upload_error: "Resim yükleme hatası!",
    service_unavailable:
      "Bu servis kullanılamıyor – Sunucudan veri yüklenirken bir hata oluştu",
    qr_address_taken: "Bu QR adresi zaten alınmış",
  },
  add_working_time: "Çalışma Saati Ekle",
  selected_day: "Seçilen Gün",
  range_name: "Zaman Aralığı Adı",
  add: "Ekle",
  first_shift: "Birinci Vardiya",
  second_shift: "İkinci Vardiya",
  start_time: "Başlangıç Saati",
  end_time: "Bitiş Saati",
  date_range: "Tarih Aralığı",
  all_week_days: "Haftanın Tüm Günleri",
  saturday_to_wednesday: "Cumartesiden Çarşambaya",
  saturday_to_thursday: "Cumartesiden Perşembeye",
  work_week: "Haftanın Tüm Günleri (tatiller hariç)",
  feedbacks: "Geri Bildirimler",
  failed_retrieve_feedback: "Geri bildirimler alınamadı!",
  province: "İl",
  search_city_placeholder: "İstediğiniz şehir adını arayın.",
  search_city_label: "Şehir Arama",
  welcome: "Uygulamamıza hoş geldiniz",
  description: "Bu çok dilli bir uygulamadır.",
  soon: "Yakında",
  beta_version: "Beta sürümü",
  defaults_cleared_success: "Varsayılan veriler başarıyla temizlendi",
  defaults_reset_success: "Varsayılan veriler başarıyla sıfırlandı",
  select_navigator_after_location_click:
    "Konum tıkladıktan sonra istediğiniz tarayıcıyı seçin",
  no_address_selected: "Adres seçilmedi",
  no_location_selected: "Konum seçilmedi",
  region: "Bölge",
  api_unauthorized: "Kimlik doğrulama hatası: Geçersiz API anahtarı",
  location_not_found: "Konum bulunamadı",
  addCategory: "Yeni kategori ekle",
  editCategory: "Kategoriyi düzenle",
  deleteCategory: "Seçilen kategori silinsin mi?",
  addProduct: "Yeni ürün ekle",
  saveProducts: "Varsayılan ürünleri seç",
  addSubCategory: "Alt kategori ekle",
  product: "Ürün",
  categoryName: "Kategori adı",
  subCategoryName: "Alt kategori adı",
  confirmDeleteProduct: "Ürün kategoriden silinsin mi?",
  successMessages: {
    categorySaved: "Kategoriler başarıyla kaydedildi.",
    productSaved: "Ürünler başarıyla kaydedildi.",
    productDeleted: "Ürün başarıyla silindi.",
  },
  errorMessages: {
    saveCategoryFailed: "Kategorileri kaydetme hatası!",
    saveProductFailed: "Ürünleri kaydetme hatası!",
    deleteCategoryFailed: "Kategoriyi silme hatası!",
  },
  add_edit_categories: "Kategori ekle/düzenle",
  copy_category: "Kategoriyi kopyala",
  product: "Ürün {point}",
  copy_product: "Ürünü kopyala",
  add_edit_products: "Ürün ekle/düzenle",
  edit_category: "Kategoriyi düzenle",
  category_name: "Kategori adı",
  edit_subcategory: "Alt kategoriyi düzenle",
  subcategory_name: "Alt kategori adı",
  add_new_category: "Yeni kategori ekle",
  store_management: "Mağaza yönetimi",
  manage_products: "Ürün yönetimi",
  products_export: "Ürünleri indir",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "Excel dosyası yükle",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "Excel dosyanızı buraya sürükleyin veya",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "seçin",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "yüklemek için",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE":
    "Lütfen sadece Excel dosyaları yükleyin (.xlsx)",
  "GENERAL.SUBMIT": "Gönder",
  "GENERAL.CANCEL": "İptal",
  "GENERAL.SUCCESSFULLY_ADDED": "Ürünler başarıyla yüklendi",
  SUCCESSFULLY_DOWNLOADED: "Ürünler başarıyla indirildi",
  "GENERAL.ERROR": "Bir hata oluştu",
  EditSubCategoty: "Alt kategoriyi düzenle",
  create: "Oluştur",
  save_changes: "Değişiklikleri kaydet",
  buy_button_settings: "Satın alma düğmesi ayarları",
  image: "Görsel",
  color: "Renk",
  title: "Başlık",
  price: "Fiyat",
  discount: "İndirim",
  percent: "Yüzde",
  amount: "Tutar",
  brand: "Marka",
  inventory: "Stok",
  inventory_hint: "Boş bırak = sınırsız sipariş miktarı",
  order_limit: "Sipariş başına maks. miktar",
  order_limit_hint: "Boş bırak = limitsiz",
  packing_price: "Paketleme ücreti",
  packing_price_hint: "Dış siparişler için uygulanır (kurye/yerinde alım).",
  description: "Açıklama",
  options: "Seçenekler",
  product_features: "Ürün özellikleri",
  field_required: "Zorunlu alan.",
  min_length: "En az 3 karakter gerekli.",
  product: "Ürün",
  default_brand: "Apple",
  product_added_success: "Ürün başarıyla eklendi",
  product_added_error: "Ürün ekleme hatası",
  whole_categories: "(Tüm kategoriler)",
  add_select_category: "Kategori ekle/seç",
  select_default_category: "Varsayılan kategoriyi seç",
  deleted_product: "Ürünü sil",
  confirm_delete_prooduct: "Ürün kategoriden silinsin mi?",
  please_wait_store_product: "Ürünler kaydediliyor, lütfen bekleyin...",
  saved_product_success: "Ürünler başarıyla kaydedildi.",
  error_in_store: "Kaydetme hatası",
  delete_category: "Kategoriyi sil",
  confirm_delete_category: "Kategori başarıyla silindi.",
  error_delete_category: "Kategoriyi silme hatası!",
  productOptionEditor: {
    tabs: {
      color: "Renk",
      size: "Boyut",
      count: "Adet",
      weight: "Ağırlık",
      type: "Tür/Cins",
    },
    fields: {
      count: "Adet",
      max_order: "Sipariş başına maks. adet",
      price: "Fiyat",
      discount: "İndirim",
      color: "Renk",
      color_name: "Renk adı",
      inventory: "Stok",
      size: "Boyut",
      type: "Tür/Cins",
      weight: "Ağırlık",
    },
    actions: {
      delete: "Sil",
      add_location: "Seçenek ekle",
    },
  },
  extraSubProducts: {
    feature: "Özellik",
    name_label: "Ad",
    name_placeholder: "Örnek: Ekstra sos / Ekstra ekmek",
    price_label: "Fiyat",
    price_hint: "Boş bırak = ücretsiz ekleme.",
    price_placeholder: "Örnek: Su, Tür (ör. tavuk göğsü/buton)",
    add_subproduct: "Ek ürün ekle",
  },
  error_selected_category: "Kategori seçme hatası!",
  suggestinput: {
    title: "Emoji seç",
    aboutUs: "Hakkımızda",
    error: "Hata",
    errorMessage: "Lütfen kredinizi yükleyin ve tekrar deneyin.",
    generateText: "AI metin önerisi",
    emoji: "Emoji",
    errorMessage_400:
      "'Hakkımızda' metni oluşturma hatası. Lütfen tekrar deneyin.",
    errorMessage_403:
      "'Hakkımızda' metni oluşturma hatası. Paket satın alın ve tekrar deneyin",
  },
  togetherai: {
    buy_package: "Paket satın al",
    tax_notice: "Paket fiyatına %10 KDV eklenecek!",
    package: "Paket",
    rial: "Riyal",
    buy_button: "Satın al!",
    discount_label: "İndirim kodu",
    submit_discount: "Uygula",
    success_message: "QR'nız başarıyla yükseltildi.",
    error_insufficient_funds:
      "Kredinizi kontrol edin ve daha sonra tekrar deneyin.",
    error_upgrade: "QR yükseltme hatası!",
    error_title: "Hata",
    success_title: "Başarı",
  },
  category_not_found: "Kategori bulunamadı!",
  create_upload_category: "Kategori oluştur ve yükle",
  add_subcategory: "Alt kategori ekle",
  error_upload_m_video: "Video yükleme hatası (erişim kısıtlı olabilir).",
  info_show_video: "'Daha fazla' tıklayarak daha fazlasını göster.",
  error_not_valid_guide_id: "Geçersiz rehber ID'si!",
  error_give_guide_info: "Rehber bilgisi alma hatası!",
  info_success_saved: "Başarıyla kaydedildi",
  error_add_new_guide: "Yeni rehber ekleme hatası",
  popup: {
    details: "Detaylar",
    guide_images: "Rehber görselleri",
    guide_videos: "Rehber videoları",
    faq: "SSS",
    no_title: "Başlık yok",
    no_content: "Gösterilecek içerik yok",
    no_questions: "Gösterilecek soru yok",
    video_error: "Video yükleme hatası (erişim kısıtlı olabilir)",
    no_answer: "Cevap yok",
    question_no_title: "Başlıksız soru",
    default_title: "Rehber",
  },
  productPicker: {
    select_default_product: "Varsayılan ürünü seç",
    search: "Ara",
    select_all_products: "Tüm ürünleri seç",
    back: "Geri",
    no_products_in_category: "Bu kategoride ürün yok!",
    products_error: "Ürünleri yükleme hatası!",
    retry: "Tekrar dene",
    items_per_page: "Sayfa başına öğe",
    root_breadcrumb: "/",
  },
  end_date: "Bitiş tarihi",
  filters: {
    userType: {
      legal: "Tüzel kişi",
      individual: "Bireysel",
    },
    serviceType: {
      Payamakland: "Payamakland",
      Coreland: "Coreland",
      Qrland: "Qrland",
      Robotland: "Robotland",
      billboard: "Billboard",
      tablighNegar: "TablighNegar",
      unknown: "Bilinmeyen",
    },
    qrType: {
      attendanceqr: "Yoklama / Katılım",
        gift: "Anı Çerçevesi",
        instagram: "Instagram",
        visitCard: "Kartvizit",
        Business: "Kişisel / Kurumsal",
        Commericial: "Ticari / Ofis Kompleksi Web Sitesi",
        qrlink: "QR Bağlantısı",
        labelproduct: "Ürün Etiketi",
        goldLabel: "Altın Etiketi",
        bShop: "Mağaza",
        SocialMedia: "Sosyal Medya",
        VideoGallery: "Video Galerisi",
        PhotoGallery: "Fotoğraf Galerisi",
        voiceGallery: "Ses Galerisi",
        consultationQr: "Talep Formu",
        application: "Uygulama",
        feedbackGallery: "Geri Bildirim",
        voiceGalleryPro: "Profesyonel Ses Galerisi",
        singleProduct: "Ürün Tanıtımı",
        menu: "Menü",
        appointment: "Randevu",
        insurance: "Sigorta",
        text: "Metin",
        luck_wheel: "Şans Çarkı",
        pdfgallery: "PDF Galerisi",
        productpro: "Pro Ürün Tanıtımı",
        multicard: "Çoklu Kart",
        catalog: "Katalog",
        visitCard_pro: "Pro Kartvizit",
        clickyarseo: "ClickYar SEO QR",
    },
    expire: {
      day: "Gün",
      expired: "Süresi dolmuş",
    },
    numericPersianNumber: {
      thousand: "Bin",
      million: "Milyon",
    },
    dateString: {
      at: "saat",
    },
    messages: {
      pleaseLogin: "Lütfen giriş yapın",
      invalidPhone: "Geçersiz telefon numarası",
      copied: "Kopyalandı",
    },
  },
  nextButton: "Sonraki",
  previousButton: "Önceki",
  rowsPerPageText: "Sayfa başına satır",
  noDataText: "Gösterilecek veri yok",
  placeholderSearch: "Ara..",
  set_qr: "QR kaydedildi",
  numbers: "Sayılar",
  enter_param_product: "Ürün verilerini doğru girin!",
  instagram_hint: "Instagram'ınızı girin",
  whatsapp_hint: "WhatsApp'ınızı girin",
  telegram: "Telegram",
  telegram_hint: "Telegram'ınızı girin",
  userpicker: {
    select_user: "Kullanıcı seç",
    choice_users: "Kullanıcılar seç",
    id: "ID",
    phone_number: "Cep telefonu",
    date_created: "Oluşturma tarihi",
    info_edit: "Bilgileri düzenle",
    name_family: "Ad ve soyad",
    position: "Pozisyon ve rütbe",
    phone: "Telefon numarası",
    discription: "Açıklama",
  },
  search_product: "Ürün ara",
  search_name_product: "Ürün adı ara",
  currency: "Riyal",
  headers: {
    index: "Sıra",
    gallery: "Görsel",
    id: "ID",
    name: "Ad",
    brand: "Marka",
    price: "Tutar",
    discount_amount: "İndirim",
  },
  search_categories: "Kategorilerde ara",
  delete_all: "Tümünü sil",
  select_category: "Kategori seç",
  currency1: "İran Riyali",
  features: "Özellikler",
  product_sp: {
    edit: "Düzenle",
    back: "Geri",
    save: "Kaydet",
    add_product_to_special_category:
      "Özel kategoriye ürün eklemek için alanları doldurun",
    inventory: "Stok",
    discount: "İndirim",
    max_per_customer: "Müşteri başına maks.",
    max_per_order: "Sipariş başına maks.",
    expires_at: "Son kullanma tarihi",
    field_cannot_be_empty: "Alan boş olamaz.",
    please_enter_correctly: "Lütfen doğru doldurun!",
    currency: "İran Riyali",
  },
  selectproduct: "Ürün seç",
  section: {
    edit_part: "Bölümü düzenle",
    title: "Başlık",
    position_text: "Metin pozisyonu",
    add_video: "Video ekle",
    text: "Metin",
    address_video: "Video URL'si",
    position_left: "Sol",
    position_right: "Sağ",
    tab_edit_button: "Düzenleme düğmesi",
    tab_content: "Bölüm içeriği",
  },
  name_shopping: "Mağaza adı",
  hint_shopping: "Mağaza adınızı girin.",
  title_discount: "İndirim başlığı",
  hint_discount: "İndirim başlığınızı girin.",
  hint_mount_discount: "Sonraki siparişinizde %20 indirim.",
  label_discount: "İndirim tutarını girin",
  give_discount: "İndirim kodu al",
  give_copon: "Kupon al",
  enter_copon: "Kuponu girin",
  hint_phone: "Telefon numaranızı girin.",
  label_phone: "Telefon numarası",
  hint_condition_discount: "İndirim koşullarını açıklayın..",
  label_discription_discount: "İndirim açıklaması",
  add_info_discount: "Ek bilgi ekle:",
  enter_address_discount: "Adresinizi girin.",
  address_discount: "Adres",
  edit_feedback: "Geri bildirimi düzenle",
  select_type_replay: "Yanıt türünü seç",
  field_discription: "Açıklama alanı",
  messages_discription:
    "Kullanıcı için açıklama alanı göstermek için etkinleştirin",
  number_char: "Karakter sayısı 3 ile 50 arasında olmalı!",
  search: "Ara",
  no_videos_found: "Video bulunamadı!",
  upload_video_prompt: "Video eklemek için video yükleme alanını kullanın",
  delete_success: "Başarıyla silindi.",
  tabs: {
    qr_view: "QR görünümü",
    preview: "Önizleme",
    ready_video: "Hazır video",
    video_gallery: "Video galerisi",
    link: "Bağlantı",
    video_upload: "Video yükle",
  },
  consultation: {
    name: "Ad",
    surname: "Soyad",
    phone: "Cep telefonu",
    nationalId: "Ulusal kimlik numarası",
    nationalIdAuthenticate: "Ulusal kimliği doğrula",
    nationalIdCorrect: "Ulusal kimlik doğruluğunu kontrol et",
    mail: "E-posta",
    address: "Adres",
    location: "Konum",
    custom: "Özel",
    customLabel: "Başlık",
    customOptions: "Seçenekler",
    optional: "İsteğe bağlı",
    require: "Zorunlu",
    description: "Açıklama",
  },
  add_section: "Bölüm ekle",
  add_new_text_section:
    "QR-Land'in akıllı dijital ülkesine sıcak davetlisiniz.",
  btn_title_section: "Ücretsiz kayıt",
  shop: {
    step_products_and_info: "Ürünler & bilgiler",
    online_store_name: "Çevrimiçi mağaza adı",
    qr_address: "QR adresi",
    qr_address_hint: "QR adresinizi girin",
    online_sale: "Çevrimiçi satış",
    step_content_settings: "İçerik ayarları",
    step_sale_settings: "Satış ayarları",
    download_qr: "QR indir",
    login_settings: "Giriş ayarları",
    store_logo_images: "Mağaza logosu ve görselleri",
    login_page_info: "Giriş sayfası bilgileri",
    upload_banner: "Banner yükle",
    user_info: "Kullanıcı bilgileri",
    create_product: "Ürün oluştur",
    special_sale: "Özel satış",
    add_social_media: "Sosyal medya ekle",
    blog: "Blog",
    services: "Hizmetler",
    faq: "SSS",
    photo_gallery: "Fotoğraf galerisi",
    video_gallery: "Video galerisi",
    pdf_gallery: "PDF galerisi",
    feedback: "Geri bildirim",
    countdown: "Geri sayım",
    request_form: "Talep formu",
    create_section: "Bölüm oluştur",
    achievements: "Başarılar",
    team_members: "Ekip üyeleri",
    working_hours: "Çalışma saatleri",
    error_saving_content: "İçerik ayarlarını kaydetme hatası!",
    success_edit_store: "Mağaza sayfası başarıyla düzenlendi.",
    post_1: "Gönderi 1",
    logo: "Logo",
    background_image: "Arka plan görseli",
  },
  discount_obj: {
    quantity: "miktar", 
    create_edit_code: "İndirim kodu oluştur/düzenle",
    coding_type_label: "Oluşturma türü",
    coding_type_single: "Tek",
    coding_type_group: "Grup",
    status_label: "Durum",
    status_active: "Aktif",
    status_deactivate: "Devre dışı",
    discount_code: "İndirim kodu",
    discount_type: "İndirim türü",
    discount_type_percent: "Yüzde",
    discount_type_fixed: "Sabit tutar",
    discount_value: "İndirim değeri",
    discount_limit: "İndirim sınırı",
    no_limit: "Sınırsız",
    tab_create_discount: "İndirim kodu oluştur",
    tab_settings: "Ayarlar",
    success_create: "İndirim kodu başarıyla oluşturuldu",
    success_edit: "İndirim kodu başarıyla düzenlendi",
    error_value_empty: "İndirim değeri boş olamaz!",
    error_start_time: "Başlangıç saati seçilmedi!",
    error_end_time: "Bitiş saati seçilmedi!",
    error_same_time: "Başlangıç ve bitiş saatleri aynı olamaz",
  },
  personnel: {
    team_members: "Seçilen ekip üyeleri",
    add_team_member: "Ekip üyesi ekle",
    default_position: "Pozisyon ve rütbe",
    default_phone: "Telefon numarası",
    default_full_name: "Tam ad",
    default_description:
      "Lorem Ipsum, matbaa endüstrisinin sahte metnidir, tasarımcılar tarafından yüzyıllardır kullanılır",
  },
  discount_settings: {
    function_type: {
      title: "İndirim fonksiyonu",
      all_shopping_cart: "Sepet toplam tutarı",
      special_products: "Özel ürünler",
      special_categories: "Özel kategoriler",
    },
    basket_condition: {
      title: "Sepet koşulları",
      no_conditions: "Koşul yok",
      minimum_shopping: "Sepet minimum tutarı",
      minimum_product: "Sepette minimum ürün",
      maximum_shopping: "Sepet maksimum tutarı",
      maximum_product: "Sepette maksimum ürün",
    },
    user_settings: {
      title: "Kullanıcı ayarları",
      all_user: "Tüm kullanıcılar",
      group: "Kullanıcı grubu",
      special: "Özel kullanıcılar",
    },
    limitation_use: {
      title: "Kullanım sınırı",
      no_limitations: "Sınırlama yok",
      discount_code: "İndirim kodu kullanım sayısı",
      user: "Kullanıcı başına kullanım",
    },
    start_time: {
      title: "İndirim başlangıç tarihi",
      no_time_selected: "Başlangıç saati seçilmedi",
    },
    end_time: {
      title: "İndirim bitiş tarihi",
      no_time_selected: "Bitiş saati seçilmedi",
    },
  },
  counterService: {
    typeLabel: "Görüntüleme türü",
    number: "Sayı",
    percent: "Yüzde",
    iconLabel: "İkon",
    counterLabel: "Değer",
    linkLabel: "Bağlantı",
    nameLabel: "Başlık",
    addButton: "Başarı ekle",
    successful: {
      added: "Öğe başarıyla eklendi",
      removed: "Öğe başarıyla kaldırıldı",
      movedUp: "Öğe başarıyla yukarı taşındı",
      movedDown: "Öğe başarıyla aşağı taşındı",
    },
  },
  qrUsersList: {
    customersList: "Müşteri listesi",
    orders: "Siparişler",
    addresses: "Adresler",
    hasAssistantsMobile_hint: "Mobil seç",
    invalidPhone: "Girilen cep telefonu numarası geçersiz",
    validation: {
      nameRequired: "İsim girilmesi zorunludur",
      nameMinLength: "İsim en az 2 karakter olmalıdır",
      familyRequired: "Soyisim girilmesi zorunludur",
      familyMinLength: "Soyisim en az 2 karakter olmalıdır",
    },
    addUser: "Kullanıcı Ekle",
    registerOnline: "Çevrimiçi kaydı etkinleştir",
    usersColumns: {
      id: "ID",
      name: "Ad",
      family: "Soyad",
      mobile: "Cep",
      subscriptionId: "Abonelik ID",
      ordersCount: "Sipariş sayısı",
      lastLogin: "Son giriş",
      status: "Durum",
      activeUser: "Aktif kullanıcı",
      none: "-",
      actions: "İşlemler",
      buttons: {
        info: "Müşteri verileri",
        sendSms: "SMS gönder",
        history: "Geçmiş",
        addresses: "Adresler",
        orders: "Siparişler",
      },
    },
    orderColumns: {
      orderId: "Sipariş numarası",
      customerName: "Müşteri adı",
      mobile: "Cep",
      paymentMethod: "Ödeme yöntemi",
      shippingMethod: "Kargo yöntemi",
      orderAmount: "Sipariş tutarı",
      orderTime: "Sipariş saati",
      status: "Durum",
      currency: "Riyal",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "Adres başlığı",
      name: "Ad",
      family: "Soyad",
      mobile: "Telefon",
      address: "Adres",
      zipCode: "Posta kodu",
      number: "Ev numarası",
      unit: "Birim",
    },
    shippingType: {
      courier: "Kurye",
      reservation: "Masa rezervasyonu",
      place: "Yerinde alım",
      none: "-",
    },
    paymentType: {
      online: "Çevrimiçi ödeme",
    },
    perPage: "Sayfa başına giriş",
    search: "Ara",
    sortColumn: "Sırala",
    sortDirection: "Sıralama yönü",
    sortDirectionDesc: "Azalan",
    sortDirectionAsc: "Artan",
    noStatus: "Durum bulunamadı",
    status: {
      all: "Tümü",
      active: "Aktif",
      inactive: "Pasif",
    },
    fetchError: "Kullanıcı verilerini yükleme hatası",
  },
  listCardHeader: {
    clear_filters: "Filtreleri temizle",
    group_qr_renewal: "Toplu QR kodu yenileme",
    select_desired_duration: "İstediğiniz süreyi seçin",
    total_count: "Toplam sayı",
    final_amount: "Son tutar",
    ten_percent_vat_will_be_added: "%10 KDV eklenecek",
    pay_and_upgrade: "Öde & yükselt",
    no_tariff_for_this_period: "Bu dönem için tarife yok",
    one_month_renewal: "1 aylık yenileme",
    three_month_renewal: "3 aylık yenileme",
    six_month_renewal: "6 aylık yenileme",
    one_year_renewal: "1 yıllık yenileme",
    selected: "Seçili",
    view: "Gör",
    details: "Detaylar",
    total_amount: "Toplam tutar",
    discount: "İndirim",
    final_amount_with_discount: "İndirimli son tutar",
    add_qr: "QR ekle",
    select_all: "Tümünü seç",
    actions: "İşlemler",
    filter: "Filtre",
    type_filter: "Tür filtresi",
    start_from: "Başlangıç",
    search: "Ara",
    id_search: "ID ara",
    filter_user: "Kullanıcı filtresi",
    sort: "Sırala",
    send_sms: "SMS gönder",
    selected_pattern: "Seçilen şablon:",
    send: "Gönder",
    newest: "En yeni",
    oldest: "En eski",
    most_visited: "En çok ziyaret",
    least_visited: "En az ziyaret",
    pause: "Duraklat",
    bulk_download: "Toplu indirme",
    activate: "Etkinleştir",
    deactivate: "Devre dışı bırak",
    error_loading_card: "Kart verilerini yükleme hatası!",
    error_fetching_prices: "Fiyatları alma hatası!",
    error_payment: "Ödeme hatası!",
    sms_success: "SMS başarıyla gönderildi",
    generic_error: "Bir hata oluştu!",
  },
  headerTypeFilter: {
    qr_model: "QR modeli",
    all_qr_models: "Tüm QR modelleri",
  },
  menuOrderFactor: {
    order_invoice: "Sipariş faturası",
    total: "Toplam",
    tax: "Vergi",
    shipping_cost: "Kargo ücreti",
    packing_cost: "Paketleme ücreti",
    discount: "İndirim",
    final_total: "Son toplam",
    currency: "Riyal",
    titles: {
      default_title: "Standart sipariş",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "Listede ara",
    search: "Ara",
    start_from: "Başlangıç",
  },
  headerStatusFilter: {
    all_qr_codes: "Tüm QR kodları",
    active_qr_codes: "Aktif QR kodları",
    inactive_qr_codes: "Pasif QR kodları",
    expiring_qr_codes: "Yakında süresi dolacak QR kodları",
    expired_qr_codes: "Süresi dolmuş QR kodları",
  },
  qrOrdersList: {
    title: "Sipariş listesi",
    orderColumns: {
      index: "Sıra",
      id: "Sipariş numarası",
      customerName: "Müşteri adı",
      mobile: "Cep",
      paymentType: "Ödeme türü",
      shippingType: "Kargo türü",
      price: "Sipariş tutarı",
      createdAt: "Sipariş saati",
      status: "Durum",
      actions: "İşlemler",
    },
    productsColumns: {
      productId: "Ürün ID",
      image: "Görsel",
      productName: "Ürün adı",
      unitPrice: "Birim fiyat",
      quantity: "Adet",
      totalPrice: "Toplam fiyat",
    },
    actions: {
      products: "Sipariş listesi",
      print: "Siparişi yazdır",
      share: "Siparişi paylaş",
      status: "Durumu değiştir",
    },
    shippingType: {
      courier: "Kurye",
      reservation: "Masa rezervasyonu",
      place: "Yerinde alım",
      post: "Posta kargosu",
      unknown: "-",
    },
    paymentType: {
      online: "Çevrimiçi ödeme",
      place: "Yerinde ödeme",
      unknown: "-",
      card2card:"Karttan Karta Ödeme",
    },
    status: {
      all: "Tümü",
      pending: "Ödeme bekleniyor",
      accepted: {
        place: "Yerinde ödeme",
        paid: "Ödendi",
      },
      delivered: "Teslim edildi",
      rejected: "Ödeme başarısız",
    },
    factorTitle: "Sipariş faturası",
    printFactor: "Faturayı yazdır",
    fetchError: "Verileri yükleme hatası",
    statusChanged: "Durum başarıyla değiştirildi",
    statusChangeError: "Durum değiştirme hatası",
    currency: "Riyal",
    perPage: "Hesap",
    search: "Ara",
    noStatus: "Durum yok",
    loading: "Yükleniyor...",
    noShippingType: "Kargo türü yok",
    noPaymentType: "Ödeme türü yok",
    sortColumn: "Sıralama sütunu",
    sortDirection: "Sıralama yönü",
    sortDirectionDesc: "Azalan",
    sortDirectionAsc: "Artan",
    selectNewStatus: "Yeni durum seç",
    changeStatusTitle: "Durumu değiştir",
    linkCopied: "Bağlantı kopyalandı.",
  },
  qrUserTransfer: {
    title: "Mülkiyet transferi",
    radioLabels: {
      userTransfer: "Başka bir kişiye transfer et",
      givingAccess: "Erişim ver",
    },
    inputLabels: {
      phone: "Kişinin cep numarası",
    },
    hints: {
      addNumber: "Eklemek için Enter veya + tuşuna basın",
      addNumberStep2: "Eklemek için Enter veya + tuşuna basın",
    },
    buttons: {
      transfer: "Transfer et",
      giveAccess: "Erişim ver",
      back: "Geri",
      saveChanges: "Değişiklikleri kaydet",
      cancel: "İptal",
        "add": "Ekle"

    },
    tooltips: {
      deleteAccess: "Erişimi kaldır",
    },
    subtitles: {
      accessList: "Yetkili kullanıcı listesi:",
      selectPermissions: "İzinleri seç:",
    },
    permissionList: {
      edit_name: "Hizmet adını düzenle",
      edit_link: "Bağlantıyı düzenle",
      edit_info: "Bilgileri düzenle",
      edit_design: "QR tasarımını düzenle",
      edit_settings: "QR ayarlarını düzenle",
      toggle_access: "Erişimi aç/kapat",
      view_customers: "Müşteri listesini gör",
      view_orders: "Sipariş listesini gör",
    },
    messages: {
      invalidPhone: "Geçersiz telefon numarası",
      duplicatePhone: "Yinelenen numara izin verilmez",
      updateAccessSuccess: "Erişim başarıyla güncellendi.",
      updateAccessError: "Güncelleme hatası: {message}",
      deleteAccessSuccess: "Erişim başarıyla kaldırıldı.",
      deleteAccessError: "Kaldırma hatası: {message}",
      fetchAccessError: "Yükleme hatası: {message}",
      transferSuccess: "QR başarıyla transfer edildi.",
      transferError: "Transfer hatası: {message}",
      giveAccessSuccess: "Başarıyla ayarlandı.",
      giveAccessError: "Ayar hatası: {message}",
      confirmDeleteAccess:
        "Bu kişinin erişimini gerçekten kaldırmak istiyor musunuz?",
    },
  },
  form: {
    form_download: "Alınan formlar",
    form_add: "Form ekle",
    formdownload: "Alınan form",
    create_at: "Oluşturulma:",
    shown: "Gösterildi",
    nogiveform: "Alınan formunuz yok",
    back: "Geri",
    invalid_date: "Geçersiz tarih",
    select_date: "Tarih seç",
    select: "Seç",
    clear: "Temizle",
    now: "Şimdi",
  },
  dsBasketCondition: {
    title: "Sepet minimum koşulları",
    items: {
      NoConditions: "Koşul yok",
      MinimumShopping: "Sepet minimum tutarı",
      MinimumProduct: "Sepette minimum ürün",
      MaximumShopping: "Sepet maksimum tutarı",
      MaximumProduct: "Sepette maksimum ürün",
    },
  },
  dsUserSettings: {
    title: "Sepet minimum koşulları",
    groupTitle: "Şu kullanıcılar",
    specialTitle: "Kullanıcılar",
    labels: {
      minimumCart: "Sepet minimum koşulları",
      users: "Kullanıcılar",
    },
    items: {
      AllUser: "Tüm kullanıcılar",
      group: "Kullanıcı grubu",
      special: "Özel kullanıcılar",
    },
    groupItems: {
      Order: "Zaten satın almış",
      noOrder: "Henüz satın almamış",
    },
  },
  qrAddressUpdate: {
  title: "Adresi Düzenle",
  labels: {
    address: "QR Adresi",
  },
  hints: {
    allowedChars: "Yalnızca İngilizce harfler, rakamlar, kısa çizgi (-) ve alt çizgi (_) kullanılabilir",
  },
  buttons: {
    removeInvalidChars: "Geçersiz Karakterleri Kaldır",
  },
  errors: {
    minLength: "En az 3 karakter gereklidir",
    invalidChars: "Geçersiz karakter! Yalnızca İngilizce harfler, rakamlar, - ve _ kullanın.",
    invalidAddress: "Girilen adres geçersiz",
    updateFailed: "Adres güncellenirken hata oluştu",
  },
  successMessage: "Adres başarıyla güncellendi",
  warning: "Uyarı",
  warningMessage: "Adresi değiştirmek önceki bağlantıların çalışmamasına neden olacaktır.",
  savePrompt: "Bu değişikliği kaydetmek istediğinizden emin misiniz?",
},
  dsFunctionType: {
    title: "İndirim uygulanır",
    productListTitle: "Ürün listesi",
    categoryListTitle: "Kategori listesi",
    labels: {
      applyDiscount: "İndirimi uygula",
      category: "Kategori",
    },
    items: {
      AllShoppingCart: "Sepet toplam tutarı",
      SpecialProducts: "Özel ürünler",
      SpecialCategories: "Özel kategoriler",
    },
  },
  dsLimitationUse: {
    title: "Kullanım sınırı",
    discountCodeTitle: "Kod kullanımları",
    userTitle: "Kullanıcı başına kullanımlar",
    labels: {
      limitation: "Sınırlama",
      usage: "Kullanım",
      user: "Kullanıcı",
    },
    items: {
      NoLimitations: "Sınırlama yok",
      DiscountCode: "İndirim kodu kullanımları",
      User: "Kullanıcı başına kullanımlar",
    },
  },
  ManageHourLimitQr: {
    noLimit: "Sınırsız",
    dateLimit: "Tarih sınırı",
    timeLimit: "Saat sınırı",
    startDate: "Başlangıç tarihi",
    endDate: "Bitiş tarihi",
    selectDate: "Tarih seç",
    startTime: "Başlangıç saati",
    endTime: "Bitiş saati",
  },
  discount_percent_range: "İndirim 0 ile 100% arasında olmalı",
  discount_price_range: "İndirim 0 ile {max} arasında olmalı",
  invalid_number: "Sadece sayı girin",
  min_order_cart: "Sipariş minimum değeri",
  preparation_time: "Hazırlama süresi (dakika)",
  delivery_time: "Teslimat süresi (dakika)",
  max_product_in_order: "Sipariş başına maks. ürün",
  max_order_by_person: "Kişi başına maks. sipariş",
  send_by_courier_price: "Kurye ücreti",
  vat: "Vergi oranı",
  send_by_post: "Posta kargo ücreti",
  online_pay: "Çevrimiçi ödeme",
  pay_in_person_place: "Yerinde ödeme",
  in_place: "Yerinde alım",
  table_booking_ability: "Masa rezervasyonu",
  send_by_courier: "Kurye ile gönderim",
  vat_switch: "Vergi",
  invalid_number: "Sadece sayı girin",
  positive_number: "Sayı pozitif olmalı",
  vat_range: "Vergi oranı 0 ile 100% arasında olmalı",
  sort_column: "Sıralama sütunu",
  direction_sort: "Sıralama yönü",
  listFeedbackUser: {
    no_questions: "Geri bildirim toplamak için sorunuz yok",
    add_feedback_prompt: "'Ekle' sekmesinde yeni geri bildirim oluşturun",
    question_label: "Soru",
    show_answers: "Cevapları göster",
    back_button: "Geri",
    no_feedback: "Geri bildirim yok!",
    user_opinion: "Kullanıcı görüşü",
    score_label: "Puan",
  },
  manageDiscount: {
    createNewDiscount: "Yeni indirim kodu oluştur",
    copy: "Kopyala",
    row: "Satır",
    id: "ID",
    discountCode: "İndirim kodu",
    usageLimit: "Kullanım sınırı",
    used: "Kullanıldı",
    manage: "Yönet",
    edit: "Düzenle",
    delete: "Sil",
    sendSms: "Hedef gruba SMS gönder",
    copySuccess: "İndirim kodu kopyalandı",
    copyError: "Kopyalama hatası",
    deleteSuccess: "İndirim kodu silindi",
    deleteError: "İndirim kodu silme hatası",
    smsSuccess: "İndirim kodu hedef gruba gönderildi",
    smsError: "Gönderme hatası",
  },
  manageTableReservation: {
    table: "Masa",
    number: "Masa {num}",
    add_table: "Masa ekle",
    complete_info_for_customer: "Müşteriye gösterilecek bilgileri doldurun",
    select_image: "Görsel seç",
    table_name_number: "Masa adı/numarası",
    number_of_seats: "Koltuk sayısı",
    type: "Tür",
    reservation_cost: "Rezervasyon maliyeti",
    enter_table_name: "Masa adı/numarasını girin",
    table_type: "Masa",
    couch_type: "Kanepe",
    gazebo_type: "Çardak",
  },
  create_menu: {
    data: {
      visitName_label: "Ziyaret adı",
      organizationName: "Büyük fast-food zinciri",
      subOrgan: "Bizimle fast-food'un en iyi tadını deneyin",
      aboutUs:
        "Büyük Fast-Food – kalite ve müşteriye saygı ile en iyisini sunuyoruz.\nKalite bizim prensibimizdir.\nFast-food sektöründe özel sandviçlerimizle hızlı yemek dünyasına yeni bir tat getirdik.\nHer gün idari etkinliklerde, doğum günlerinde ve daha fazlasında size hizmet vermeye hazırız...",
      copyright: "Bu sitenin tüm hakları Terminal Advertising'e aittir.",
      product: {
        title: "Ürünler",
        pizzas: "Pizzalar",
        pizza_roast_beef: "Pizza Roast Beef",
        pizza_roast_beef_desc: "🤩 İtalyan pizza sığır etiyle",
        pizza_roast_beef_ingredients:
          "30 cm İtalyan pizza tabanı, 100 g kıyma sığır eti, mantar, biber, siyah zeytin",
        pizza_chicken_mushroom: "Pizza Tavuk & Mantar",
        pizza_chicken_mushroom_desc: "🍕 Klasik 40 cm",
        pizza_chicken_mushroom_ingredients:
          "Taze Pizzara domates sosu, pastörize peynir, tavuk fileto, mantar, dağ kekiği",
        pizza_meat_mushroom: "Pizza Et & Mantar",
        pizza_meat_mushroom_desc: "🥰 Kıyma sığır eti ve mantarlı pizza",
        pizza_meat_mushroom_ingredients:
          "Taze Pizzara domates sosu, pastörize peynir, üst kalite kıyma sığır eti, mantar, dağ kekiği, 2 kişi için (29 cm) 355.000 Toman, 1 kişi için (22 cm) 216.000 Toman",
        pizza_veggie: "Vejetaryen Pizza",
        pizza_veggie_desc: "🍕 Amerikan vejetaryen pizza",
        pizza_veggie_ingredients:
          "Amerikan pizza tabanı, tatlı mısır, mantar, zeytin, domates, soğan, biber, pizza peyniri",
        pizza_special: "Özel Pizza",
        pizza_special_desc: "Amerikan özel pizza",
        pizza_special_ingredients:
          "Amerikan pizza tabanı, baharatlı kıyma sığır eti, hamburger karışımı sığır & tavuk %80, mozzarella karışımı, özel sos, biber, mantar, 1 kişi için sossuz",
        pizza_bolognese: "Pizza Bolognese",
        pizza_bolognese_desc: "(1 kişi için) 23 cm pizza tabanı 🤌",
        pizza_bolognese_ingredients:
          "Kıyma sığır eti, mozzarella, mantar, biber, tatlı mısır, dilimlenmiş siyah zeytin",
        pizza_pepperoni: "Pizza Pepperoni",
        pizza_pepperoni_desc: "(1 kişi için) 23 cm pizza tabanı",
        pizza_pepperoni_ingredients:
          "İtalyan pizza tabanı, pepperoni %80, marinara sos, özel pizza peyniri",
        pizza_bacon: "Pizza Bacon",
        pizza_bacon_desc: "(1 kişi için) 23 cm pizza tabanı 💥",
        pizza_bacon_ingredients:
          "İtalyan pizza tabanı, marinara sos, özel pizza peyniri, bacon karışımı sığır & tavuk %90, mantar, zeytin, biber",
        pizza_mixed: "Karışık Pizza",
        pizza_mixed_desc: "(1 kişi için) 23 cm pizza tabanı 🤭",
        pizza_mixed_ingredients:
          "Hamburger karışımı sığır & tavuk kıyma, salam, kıyma sığır eti, mantar, zeytin, biber, pizza peyniri, özel sos",
        pizza_american_steak: "Amerikan Steak Pizza",
        pizza_american_steak_desc: "(1 kişi için) 23 cm 💥",
        pizza_american_steak_ingredients:
          "Amerikan pizza tabanı, sığır eti parçaları, mantar, pizza peyniri, susam",
        burgers: "Burgerler",
        cheeseburger: "Cheeseburger",
        cheeseburger_desc: "🤩 Patates kızartmasıyla",
        cheeseburger_ingredients:
          "2 adet 150 g sığır burger köftesi, özel sos, Gouda peyniri, turşu, marul, domates",
        hamburger: "Hamburger",
        hamburger_desc: "😍 Özel soslu saf sığır eti",
        hamburger_ingredients:
          "150 g sığır burger köftesi, turşu, marul, özel sos, domates, Mac ekmek, 1 kişi için sos",
        chicken_burger: "Tavuk Burger",
        chicken_burger_desc: "Peynirli ızgara tavuk",
        chicken_burger_ingredients:
          "150 g ızgara tavuk göğsü, peynir, domates, turşu, marul, Mac ekmek, özel sos",
        spice_burger: "Baharatlı Burger",
        spice_burger_desc: "Baharatlı soslu sığır eti",
        spice_burger_ingredients:
          "130 g sığır burger köftesi, baharatlı sos, marul, domates, Mac ekmek, özel baharatlı sos",
        double_burger: "Çift Burger",
        double_burger_desc: "150 g sığır eti",
        double_burger_ingredients:
          "2 adet el yapımı 150 g sığır köftesi, pizza peyniri, karamel sos, marul, kırmızı lahana, özel beyaz sos, yuvarlak ekmek",
        royal_burger: "Royal Burger",
        royal_burger_desc: "150 g sığır eti 🍔",
        royal_burger_ingredients:
          "El yapımı 150 g sığır köftesi, pizza peyniri, 5 dilim salam, karamel sos, marul, kırmızı lahana, özel beyaz sos, yuvarlak ekmek",
        mushroom_burger: "Mantarlı Burger",
        mushroom_burger_desc: "150 g sığır eti",
        mushroom_burger_ingredients:
          "El yapımı 150 g sığır köftesi, mantar, karamel sos, marul, kırmızı lahana, özel beyaz sos, yuvarlak ekmek, mozzarella",
        mashroom_burger: "Mantarlı Burger",
        mashroom_burger_desc: "%100 ızgara sığır eti 🤩",
        mashroom_burger_ingredients:
          "El yapımı %100 ızgara sığır köftesi, patates kızartması, domates, marul, turşu, mantar sosu, yuvarlak ekmek",
        fried_burger: "Kızarmış Burger",
        fried_burger_desc: "%100 ızgara & kızarmış sığır eti 👌",
        fried_burger_ingredients:
          "El yapımı %100 ızgara & kızarmış sığır köftesi, 150 g patates kızartması, domates, marul, turşu, özel sos, yuvarlak ekmek",
        fried: "Kızarmış",
        fried_chicken: "Kızarmış Tavuk",
        fried_chicken_desc: "😍 3 parça kızarmış tavuk",
        fried_chicken_ingredients:
          "3 parça kızarmış tavuk, 120–150 g patates kızartması, 100–120 g lahana salatası, küçük ekmek, özel sos",
        chicken_strips: "Tavuk Şeritleri",
        fried_chicken_desc: "4 parça baharatlı kızarmış tavuk fileto",
        chicken_strips_ingredients:
          "4 parça kızarmış tavuk fileto, 120–150 g patates kızartması, 100–120 g lahana salatası, küçük ekmek, tartar sos",
        fried_filet: "Kızarmış Fileto",
        fried_filet_desc: "🤩 Özel soslu 2 parça kızarmış fileto",
        fried_filet_ingredients:
          "2 parça şerit, ızgara patates, lahana salatası, küçük ekmek, sarımsak sos, Tayland chili sos, paprika sos",
        fried_mushroom_onion: "Kızarmış Mantar & Soğan",
        fried_mushroom_onion_desc: "🤩 Tartar soslu kızarmış mantar & soğan",
        fried_mushroom_onion_ingredients:
          "20 parça kızarmış mantar, 6 parça kızarmış soğan halkası, tartar sos",
        fried_wings: "Kızarmış Kanatlar",
        fried_wings_desc: "6 parça kızarmış kanat 🍗",
        fried_wings_ingredients: "Altı ızgara & kızarmış kanat",
        fried_chicken_basket: "Kızarmış Tavuk Sepeti",
        fried_chicken_basket_desc: "(2 kişi için) 😍",
        fried_chicken_basket_ingredients:
          "2 parça kızarmış tavuk, 2 parça şerit, 2 parça soğan halkası, 2 parça kızarmış karides nugget, 2 parça tavuk nugget",
        fried_schnitzel: "Kızarmış Şnitzel",
        fried_schnitzel_desc: "Dört parça tavuk şnitzel 💥",
        fried_schnitzel_ingredients:
          "Dört baharatlı ızgara & kızarmış tavuk şnitzel",
        veggie_basket_fried: "Vejetaryen Kızarmış Sepet",
        veggie_basket_fried_desc: "250 g 🤩",
        veggie_basket_fried_ingredients:
          "250 g, kızarmış kabak, patlıcan, mantar, patates",
        fried_chicken_2_piece: "Kızarmış Tavuk 2 Parça",
        fried_chicken_2_piece_desc: "2 parça kızarmış tavuk 🍗",
        fried_chicken_2_piece_ingredients:
          "120–150 g patates kızartması, 100–120 g lahana salatası, küçük ekmek, özel sos",
        fried_chicken_5_piece: "Kızarmış Tavuk 5 Parça",
        fried_chicken_5_piece_desc: "Beş parça kızarmış tavuk",
        fried_chicken_5_piece_ingredients:
          "150–200 g patates kızartması, iki 100–120 g lahana salatası, iki küçük ekmek, özel sos",
        fried_chicken_7_piece: "Kızarmış Tavuk 7 Parça",
        fried_chicken_7_piece_desc: "Yedi parça kızarmış tavuk 💥",
        fried_chicken_7_piece_ingredients:
          "150–200 g patates kızartması, 100–120 g lahana salatası, 3 küçük ekmek, özel sos, 1 kişi için kızarmış sos",
        sandwich: "Sandviç",
        hotdog_sandwich: "Hotdog Sandviç",
        hotdog_sandwich_desc: "Mantar ve peynirli hotdog sandviç",
        hotdog_sandwich_ingredients:
          "Izgara hotdog sosis, marul, domates, turşu, mantar ve pizza peyniri",
        roast_beef_sandwich: "Roast Beef Sandviç",
        roast_beef_sandwich_desc: "✔️ Kıyma sığır eti",
        roast_beef_sandwich_ingredients:
          "Sığır eti, pizza peyniri, mantar, dilimlenmiş patates cipsi, marul, domates, turşu, özel sos, Fransız ekmeği",
        ham_sandwich: "Jambon Sandviç",
        ham_sandwich_desc: "Mantarlı tavuk jambon sandviç (soğuk)",
        ham_sandwich_ingredients:
          "Mantarlı tavuk jambon, marul, domates, turşu, dilimlenmiş patates cipsi, özel sos, baget",
        bandari_sausage_sandwich: "Bandari Sosis Sandviç",
        bandari_sausage_sandwich_desc: "💥 Baharatlı Bandari sandviç",
        bandari_sausage_sandwich_ingredients:
          "Bandari yemek %55 kokteyl füme sosisli, domates, turşu, özel sos, soğan ve kişniş, hacimli ekmek",
        tongue_mushroom_sandwich: "Dil & Mantar Sandviç",
        tongue_mushroom_sandwich_desc: "150 g sığır dili",
        tongue_mushroom_sandwich_ingredients:
          "Mantar, pastörize pizza peyniri, zeytin, tatlı mısır, marul, turşu, domates, sos, garnitür, patates kızartması, lahana salatası",
        falafel_sandwich: "Falafel Sandviç",
        falafel_sandwich_desc: "Altı parça falafel 🌭",
        falafel_sandwich_ingredients:
          "Altı parça falafel, turşu, domates, marul, 1 kişi için sos, garnitür, patates kızartması, lahana salatası",
        cheesy_kebab_turki_sandwich: "Peynirli Türk Kebap Sandviç",
        cheesy_kebab_turki_sandwich_desc: "150 g sığır eti",
        cheesy_kebab_turki_sandwich_ingredients:
          "150 g sığır eti, özel pizza peyniri, turşu, domates, marul, 1 kişi için sos, patates kızartması, lahana salatası",
        roast_chicken_sandwich: "Izgara Tavuk Sandviç",
        roast_chicken_sandwich_desc: "Tavuk şnitzel ve mantar 🤩",
        roast_chicken_sandwich_ingredients:
          "Tavuk şnitzel ve mantar, özel pizza peyniri, zeytin, tatlı mısır, susam, marul, biber, turşu, domates, özel sos, garnitür, patates kızartması",
        cheesy_indian_sandwich: "Peynirli Hint Sandviç",
        cheesy_indian_sandwich_desc: "Alman sosis 💥",
        cheesy_indian_sandwich_ingredients:
          "Peynirli Alman sosis, tatlı mısır, marul, mantar, özel sos, garnitür, patates kızartması, lahana salatası",
        snack: "Atıştırmalık",
        chicken_snack: "Tavuk Atıştırmalık",
        chicken_snack_desc: "😋 Kıyma tavuk göğsü",
        chicken_snack_ingredients:
          "150 g tavuk göğsü, biber, mantar, özel atıştırmalık ekmek, özel sos",
        meat_snack: "Et Atıştırmalık",
        meat_snack_desc: "🥪 Çift et atıştırmalık",
        meat_snack_ingredients:
          "Çift, üst kalite kıyma sığır eti, mozzarella, tatlı mısır, biber, özel sos, tost ekmeği",
        chicken_meat_snack: "Tavuk-Et Atıştırmalık",
        chicken_meat_snack_desc: "🤩 Çift tavuk-et atıştırmalık",
        chicken_meat_snack_ingredients:
          "Çift, kıyma tavuk göğsü, üst kalite kıyma sığır eti, mozzarella, tatlı mısır, biber, özel sos, tost ekmeği",
        special_snack: "Özel Atıştırmalık",
        special_snack_desc: "🤤 Çift özel atıştırmalık",
        special_snack_ingredients:
          "Çift, kalbas karışımı sığır & tavuk %90, mozzarella, tatlı mısır, biber, özel sos, tost ekmeği",
        roast_beef_snack: "Roast Beef Atıştırmalık",
        roast_beef_snack_desc: "Kıyma sığır eti 🍖",
        roast_beef_snack_ingredients:
          "Kıyma sığır eti, mantar, pizza peyniri, biber, tatlı mısır, garnitür, patates kızartması, lahana salatası",
        veggie_snack: "Vejetaryen Atıştırmalık",
        veggie_snack_desc: "4 parça vejetaryen atıştırmalık",
        veggie_snack_ingredients:
          "Brokoli, tatlı mısır, zeytin, diyet pizza peyniri, mantar, garnitür, patates kızartması, lahana salatası",
        chicken_mushroom_snack: "Tavuk & Mantar Atıştırmalık",
        chicken_mushroom_snack_desc: "Tavuk şnitzel ve mantar 👌",
        chicken_mushroom_snack_ingredients:
          "Tavuk şnitzel, mantar, özel pizza peyniri, zeytin, tatlı mısır, biber, garnitür, patates kızartması, lahana salatası",
        pepperoni_snack: "Pepperoni Atıştırmalık",
        pepperoni_snack_desc: "Kalbas pepperoni %90 💥",
        pepperoni_snack_ingredients:
          "Çift, kalbas pepperoni %90, mozzarella, tatlı mısır, biber, özel sos",
        bologna_snack: "Bologna Atıştırmalık",
        bologna_snack_desc: "Kıyma sığır eti 👌",
        bologna_snack_ingredients:
          "Çift, kıyma sığır eti, özel bacon, beyazlatılmış mantar, tatlı mısır, mozzarella, biber, özel sos",
        pasta: "Makarna",
        alfredo_pasta: "Alfredo Makarna",
        alfredo_pasta_desc: "Özel mantar soslu Alfredo makarna",
        alfredo_pasta_ingredients: "350 g penne",
        macaroni: "Makarna",
        macaroni_ingredients:
          "Şerit makarna 1,2, 100 g kıyma sığır eti, mantar, biber, ızgara patates küpleri, bezelye",
        spaghetti_bolognese: "Spaghetti Bolognese",
        spaghetti_bolognese_desc: "🥰 Linguine makarna",
        spaghetti_ingredients:
          "700 g, linguine makarna, sığır ve kuzu kıyma, bolognese sos, özel kırmızı Rasu sos, plastik kaşık ve çatal opsiyonel",
        chicken_stroganoff: "Tavuk Stroganoff",
        chicken_stroganoff_desc: "😍 Tavuk göğsü parçalı tavuk stroganoff",
        chicken_stroganoff_ingredients:
          "180 g baharatlı tavuk göğsü parçaları, krema, beyazlatılmış mantar, parmesan, el kesimi patates kızartması, mikrodalga özel kap",
        penne_arrabbiata: "Penne Arrabbiata",
        penne_arrabbiata_desc: "Tavuk göğsü 💥",
        penne_arrabbiata_ingredients:
          "1 kişi için, tavuk göğsü, makarna, mantar, parmesan, çeri domates, maydanoz, arrabbiata sos",
        chicken_pesto_pasta: "Tavuk Pesto Makarna",
        chicken_pesto_pasta_desc: "(1 kişi için) Tavuk göğsü",
        chicken_pesto_pasta_ingredients:
          "Tavuk göğsü, mantar, parmesan, çeri domates, maydanoz, arrabbiata sos",
        carbonara_pasta: "Carbonara Makarna",
        carbonara_pasta_desc: "%97 sığır bacon",
        carbonara_pasta_ingredients:
          "Makarna, %97 sığır bacon, alfredo sos, parmesan, çeri domates, maydanoz",
        appetizer: "Mezeler",
        hot_chips: "Sıcak Cips",
        hot_chips_desc: "😙 Çeşitli cips tatları",
        hot_chips_ingredients:
          "Kilo cips, özel sos, %70 tavuk jambon, mantar, biber, pizza peyniri, Gouda",
        lasagna: "Lazanya",
        lasagna_desc: "Kıyma sığır etli lazanya",
        lasagna_ingredients:
          "3 lazanya yaprağı, kıyma sığır eti, mantar, biber, siyah zeytin, pizza peyniri, özel sos",
        french_fries: "Patates Kızartması",
        french_fries_desc: "Özel soslu patates kızartması",
        french_fries_ingredients: "150 gr patates kızartması, özel sos",
        baked_potato: "Fırın Patates",
        baked_potato_desc: "🍟 Sığır pastırmalı fırın patates",
        baked_potato_ingredients:
          "150 gr patates kızartması, sığır pastırması %90, pizza peyniri, özel baharat, tek kişilik sos",
        garlic_bread: "Sarımsaklı Ekmek",
        garlic_bread_desc: "Özel sarımsak sosu💥",
        garlic_bread_ingredients:
          "Amerikan pizza hamuru, karışık pizza peyniri, özel sarımsak sosu, susam",
        silo_potatoes: "Silo Patates",
        silo_potatoes_desc: "İki kişilik patates kızartması",
        silo_potatoes_ingredients:
          "Silo baharatlı patates kızartması, sığır pastırması %97, çedar sos, aioli, yeşil soğan, maydanoz",
        bbq_sausage: "Barbekü Sosis",
        bbq_sausage_desc: "Marine edilmiş parmak sosis🍢",
        bbq_sausage_ingredients:
          "500 gr baharatlı patates püresi, 200 gr marine edilmiş parmak sosis, soğan halkası, yeşil zeytin, parmesan peynir tozu, çeri domates, mikro yeşillik, ızgara peynir, barbekü sos, acı",
        silo_toast: "Silo Tost",
        silo_toast_desc: "160 gr dana bonfile dilimleri🤩",
        silo_toast_ingredients:
          "160 gr dana bonfile dilimleri, Fransız marul, sığır pastırması, çiftçi ekmeği, barbekü sos, tartar sos, kuzukulağı, yeşil zeytin, mikro yeşillik, aioli, parmesan peynir tozu",
        salad_and_dessert: "Salata ve Tatlı",
        caesar_salad: "Sezar Salatası",
        caesar_salad_desc: "Tek kişilik Sezar salatası🥗",
        caesar_salad_ingredients:
          "Karışık marul, ızgara tavuk, parmesan peyniri, kruton (sarımsaklı ekmek), Sezar sos, zeytin",
        caesar_salad_extra: "Roma marul, kruton, parmesan",
        coleslaw_salad: "Lahana Salatası",
        coleslaw_salad_desc: "Tek kişilik lahana salatası🍴",
        coleslaw_salad_ingredients:
          "El yapımı, tek kişilik, beyaz lahana, mısır, sos",
        macaroni_salad: "Makarna Salatası",
        macaroni_salad_desc: "Ev yapımı jambonlu makarna salatası",
        macaroni_salad_ingredients: "Makarna, ev yapımı jambon",
        pachira_salad: "Pachira Salatası",
        pachira_salad_desc: "İki kişilik Pachira salatası🥗",
        pachira_salad_ingredients:
          "İki kişilik, karışık marul, sığır pastırma cipsi %98, karamelize ceviz, parmesan peyniri, çilek, bitkisel havyar, kuru üzüm, limon dilimleri, gül çilek sosu",
        greek_salad: "Yunan Salatası",
        greek_salad_desc: "Feta peyniri ve zeytinli geleneksel Yunan salatası",
        greek_salad_ingredients: "Feta peyniri, zeytin, salatalık",
        tiramisu: "Tiramisu",
        tiramisu_desc: "Klasik İtalyan tiramisu tatlısı",
        tiramisu_ingredients: "Kahve, mascarpone, kakao",
        beverages: "İçecekler",
        local_yogurt_drink: "Yerel Yoğurt İçeceği",
        local_yogurt_drink_desc: "Aile tipi yerel yoğurt içeceği🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "Siyah Gazoz",
        black_soda_desc: "Bardakta siyah gazoz🧋",
        black_soda_ingredients: "",
        fanta: "Sarı Gazoz",
        fanta_desc: "Bardakta sarı gazoz🥤",
        fanta_ingredients: "",
        mojito: "Mojito",
        mojito_desc: "Bardakta mojito, 350-400 ml🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "Tropikal Malt İçeceği",
        tropical_malt_beverage_desc: "Bardakta tropikal malt içeceği🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "Adres",
        address_text: "İstenen web sitesi bağlantısını girin",
        instagram_label: "Instagram",
        instagram_text: "Kullanıcı adınızı girin",
        whatsapp_label: "WhatsApp",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "Video Galerisi",
        description:
          "QR-Land akıllı sistem hizmetlerini daha iyi tanımak için aşağıdaki videoları izleyin.",
        tutorial: "Eğitici",
        fast_food: "Fast Food",
      },
      feedback: {
        title: "Geri Bildiriminiz",
        description:
          "Lütfen aşağıdaki soruları yanıtlayarak hizmetlerimizi iyileştirmemize yardımcı olun",
        question1:
          "Hizmetlerimiz ve yemek kalitesinden ne kadar memnun kaldınız?",
        question2: "Restoranın yemek çeşitliliğini nasıl değerlendiriyorsunuz?",
        question3:
          "Restoran personelinin davranışlarını nasıl değerlendiriyorsunuz?",
        question4: "Yemek zamanında mı teslim edildi?",
        question5:
          "Hizmet veya yemek kalitesini iyileştirmek için öneriniz var mı?",
      },
      worksheet: {
        saturday: "Cumartesi",
        sunday: "Pazar",
        monday: "Pazartesi",
        tuesday: "Salı",
        wednesday: "Çarşamba",
        thursday: "Perşembe",
        friday: "Cuma",
        shift_1_saturday: "10:00 - 22:00",
        shift_1_sunday: "10:00 - 22:00",
        shift_1_monday: "10:00 - 22:00",
        shift_1_tuesday: "10:00 - 22:00",
        shift_1_wednesday: "10:00 - 00:00",
        shift_1_thursday: "10:00 - 00:00",
        shift_1_friday: "10:00 - 00:00",
      },
      gallery: {
        gallery_0: "Galeri 0",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "Fırın Patates 2",
        chicken_stroganoff_1: "Tavuk Stroganoff 1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "Tahran, Şeriati Caddesi, Seyed Handan Köprüsü sonrası, Handan çıkmazı, No:6, Daire:3",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "İran, Tahran, Tahran şehri, Tahran, Tahran şehri 3. bölge, Seyed Handan mahallesi, Dr. Ali Şeriati, Handan",
      },
    },
    messages: {
      qr_created_success: "Çevrimiçi menü başarıyla oluşturuldu.",
      qr_updated_success: "Çevrimiçi menü QR kodunuz başarıyla düzenlendi.",
      qr_create_error: "QR oluşturulurken hata oluştu!",
      qr_update_error: "QR kaydedilirken/düzenlenirken hata oluştu",
      template_categories_saved:
        "Örnek model kategorileri başarıyla kaydedildi.",
      template_products_saved: "Örnek model ürünleri başarıyla kaydedildi.",
      template_categories_error:
        "Örnek model kategorileri kaydedilirken hata oluştu!",
      template_products_error:
        "Örnek model ürünleri kaydedilirken hata oluştu!",
    },
    sample_menu: "Örnek Menü",
    view_qr: "QR Görüntüle",
    preview: "Önizleme",
    download_qr: "QR İndir",
    create_qr: "QR Oluştur",
    online_menu_name: "Çevrimiçi Menü Adı",
    online_menu_name_short: "Menü Adı",
    enter_qr_address: "QR adresini girin",
    qr_address: "QR Adresi",
    enter_menu_information: "Menü bilgilerini girin",
    cleardefaults: "Varsayılanları Temizle",
    select_sample_menu: "Örnek Menü Seç",
    select_ready_menu: "Hazır Menü Seç",
    online_sales: "Çevrimiçi Satış",
    sales_settings: "Satış Ayarları",
    download: "İndir",
    gallery_photos: "Galeri Fotoğrafları",
    fast_food_1: "Fast Food Resmi 1",
    fast_food_2: "Fast Food Resmi 2",
    large_chain_fast_food: "Büyük Fast Food Zinciri",
    best_fast_food_taste_experience:
      "En iyi fast food lezzetini bizimle yaşayın",
    online_menu_created_successfully: "Çevrimiçi menü başarıyla oluşturuldu.",
    qr_creation_failed: "QR oluşturulurken hata oluştu!",
    online_menu_qr_updated_successfully:
      "Çevrimiçi menü QR kodunuz başarıyla düzenlendi.",
    error_saving_updating_qr: "QR kaydedilirken/düzenlenirken hata oluştu",
    sample_model_categories_saved_successfully:
      "Örnek model kategorileri başarıyla kaydedildi.",
    sample_model_products_saved_successfully:
      "Örnek model ürünleri başarıyla kaydedildi.",
    error_saving_sample_model_products:
      "Örnek model ürünleri kaydedilirken hata oluştu!",
    error_saving_sample_model_categories:
      "Örnek model kategorileri kaydedilirken hata oluştu!",
  },
  editMenu: {
    enter_menu_information: "Menü bilgilerini girin",
    online_menu_name: "Çevrimiçi Menü Adı",
    online_menu_name_short: "Çevrimiçi Menü Kısa Adı",
    fields: {
      qr_address_hint: "Çevrimiçi menüye erişim için QR adresi",
    },
    online_sales: "Çevrimiçi Satış",
    sales_settings: "Satış Ayarları",
    shop: {
      upload_banner: "Banner Yükle",
      create_product: "Ürün Oluştur",
      user_info: "Kullanıcı Bilgileri",
      add_social_media: "Sosyal Medya Ekle",
      photo_gallery: "Fotoğraf Galerisi",
      video_gallery: "Video Galerisi",
      feedback: "Geri Bildirim",
      working_hours: "Çalışma Saatleri",
    },
    success_message: "Kartvizitiniz başarıyla düzenlendi.",
  },
  qrCodeSquare: {
    dots_color: "Nokta Rengi",
    gradient_color: "Gradyan Renk",
    linear: "Doğrusal",
    radial: "Dairesel",
    color_rotation: "Renk Dönüşü",
    first_color: "İlk Renk",
    second_color: "İkinci Renk",
    dots_color_label: "Nokta Rengi",
  },

  language: {
    selectAll: "Tümünü Seç",
    lang: {
      fa: "Farsça",
      ar: "Arapça",
      ar_ae: "Arapça (BAE)",
      ar_iq: "Arapça (Irak)",
      en_US: "İngilizce (ABD)",
      en_GB: "İngilizce (BK)",
      de: "Almanca",
      fr: "Fransızca",
      zh_CN: "Basitleştirilmiş Çince",
      zh_TW: "Geleneksel Çince",
      tr: "Türkçe",
      ru: "Rusça",
      hy: "Ermenice",
    },
    only_manual_now: "Şu anda sadece manuel çeviri mümkün",
    ai_coming_soon: "Yapay zeka çevirisi yakında aktif olacak",
    got_it: "Anladım",
    origin_language: "Kaynak Dil",
    target_languages: "Hedef Diller",
    remove_all: "Tüm Dilleri Kaldır",
    translation_method: "Çeviri Yöntemini Seçin",
    manual_translation: "Manuel Çeviri",
    ai_translation: "Yapay Zeka Çevirisi",
    coming_soon: "Yakında",
    source_language_updated: "Kaynak dil güncellendi",
    error_changing_source_language: "Kaynak dil değiştirilirken hata oluştu",
    source_language_created: "Yeni kaynak dil oluşturuldu",
    languages_saved: "Yeni diller kaydedildi",
    error_saving_languages: "Diller kaydedilirken hata",
    error_loading_language: "Dil yüklenirken hata",
    languages_removed: "Kaldırılan diller",
    new_languages_to_save: "Kaydedilecek yeni diller",
    saved: "Kaydedildi",
    management_langs: "Dil Yönetimi",
    add_langs: "Dil Ekle",
    change_language: "Dili Değiştir",
    visit_card: "Kartvizit",
    translate_to: "Şuna Çevir",
    main_language: "Dil",
    no_languages_available: "Kullanılabilir dil yok",
    return_to_default: "Varsayılan Dile Dön",
    translate: "Çevir",
    changes_pending: "Değişikliklerin uygulanması bekleniyor",
    apply_changes: "Değişiklikleri Uygula",
    cancel_changes: "İptal",
  },
  winner_list: "Kazananlar Listesi",
  qrwinnersList: {
    winnerstotalcount: "QR için toplam kazanan sayısı",
    winnerscountoffilter: "Uygulanan filtre ile kazanan sayısı",
    winnersList: "QR Kazananlar Listesi",
    prize: "Ödül",
    winnerName: "Kazanan Adı",
    date: "Tarih",
    noWinners: "Kazanan yok",
    perPage: "Sayfa başına öğe",
    search: "Kazanan adına veya ödüle göre ara",
    sortDirection: "Sıralama yönü",
    sortBy: "Sıralama kriteri",
  },
  appearance_settings: "Görünüm ayarları",
  header_color: "Başlık rengi",
  background_color: "Arka plan rengi",
  text_color: "Metin rengi",
  font_size: "Yazı tipi boyutu",
  chat_logo: "Sohbet logosu",
  floating_button_icon: "Yüzen düğme simgesi",
  assistant_name: "Asistan adı",
  chat_preview: "Sohbet önizlemesi",
  smart_assistant: "Akıllı asistan",
  online: "Çevrimiçi",
  aiChatSettings: {
    select_assistant: "Asistan Seç",
    appearance_settings: "Görünüm Ayarları",
    lead_connection_tab: "Lead Toplama - Müşteri Kulübüne Bağlan",

    header_settings: "Başlık Ayarları",
    header_settings_desc: "Sohbet başlığının rengi ve stili",
    text_settings: "Metin Ayarları",
    text_settings_desc: "Yazı rengi ve boyutu",
    logo_settings: "Logo Ayarları",
    logo_settings_desc: "Asistan fotoğrafı veya ikonu",
    background_settings: "Arka Plan Ayarları",
    background_settings_desc: "Arka plan resmi veya rengi",

    gradient_color: "Gradyan Renk",
    solid_color: "Düz Renk",
    use_image: "Resim Kullan",
    use_icon: "İkon Kullan",

    first_color: "Birinci Renk",
    second_color: "İkinci Renk",
    header_color: "Başlık Rengi",
    text_color: "Metin Rengi",
    background_color: "Arka Plan Rengi",

    font_size: "Yazı Boyutu",

    robot: "Robot",
    chat: "Sohbet",
    support: "Destek",
    question: "Soru",
    message: "Mesaj",
    assistant_voice: "Asistan",
    ai_brain: "Yapay Zeka",

    lead_connection_title: "Müşteri Kulübüne Bağlan",
    lead_alert:
      "Bu ayarlar yapıldığında, kullanıcı lead göndermeyi seçerse bilgileri Müşteri Kulübünde kaydedilecektir.",

    hasAssistantsName_label: "İsim Al",
    hasAssistantsName_hint: "Kullanıcının adını al",
    hasAssistantsFamily_label: "Soyisim Al",
    hasAssistantsFamily_hint: "Kullanıcının soyadını al",
    hasAssistantsMobile_label: "Cep Telefonu Al",
    hasAssistantsMobile_hint: "Kullanıcının cep telefonunu al",
  },
  assistantChatViewer: {
    assistant_name: "Akıllı Asistan",
    online: "Çevrimiçi",
    new_chat: "Yeni Sohbet",
    clear_chat: "Sohbeti Temizle",
    close: "Kapat",
    message_placeholder: "Mesaj...",
    processing: "İşleniyor...",
    renew: "Yenile",
    created_at: "Oluşturulma tarihi",
    last_edit: "Son düzenleme",
    copied: "Kopyalandı",
    copy: "Kopyala",
    print_qr: "QR Yazdır",
    print_visit_card: "Kartvizit Yazdır",
    send_link: "Link Gönder",
    winner_list: "Kazananlar Listesi",
    customer_list: "Müşteri Listesi",
    order_list: "Sipariş Listesi",
    reserved_appointments: "Rezerve Edilen Randevular",
    feedback: "Geri Bildirim",
    request_form: "Talep Formu",
    transfer_ownership: "Mülkiyet Transferi",
    store_management: "Mağaza Yönetimi",
    select_nfc_card: "NFC Kart Seç",
    edit: "Düzenle",
    design: "Tasarım",
    qr_settings: "QR Ayarları",
    deactivate: "Devre dışı bırak",
    download: "İndir",
    viewed: "Kez görüntülendi",
    see_more: "Daha fazla gör",
    updating_qr: "QR güncelleniyor...",
  },
  create_game: "Oyun Oluştur",
  ready_games: "Hazır Oyunlar",
  add_game: "Oyun Ekle",
  game_gallery: "Oyun Galerisi",
  game_size_error: "Oyun dosya boyutu 2MB'yi aşmamalı",
  game_upload_error: "Oyun yükleme hatası",
  no_game_available: "Hiç oyun mevcut değil",
  to_use_ready_games_search_category_or_product:
    "Hazır oyunları kullanmak için kategori veya ürün ara",
  gif_size_error: "GIF dosya boyutu 2MB'yi aşmamalı",
  previewer_page: "Önizleme Gösterimi",
  // ─────────────────────────────────────────────────────
  // Oyun, GIF ve ayarlar bölümü için çeviri anahtarları
  // Dosya: src/core/services/langs/tr.js
  // ─────────────────────────────────────────────────────
  // 1. Ana Oyun Editörü (PublicGameEditor)
  game_editor: "Oyun Düzenleyici",
  reset_defaults: "Varsayılanlara Sıfırla",
  save_and_preview: "Kaydet ve Önizle",
  texts: "Metinler",
  images: "Görseller",
  colors: "Renkler",
  general_settings: "Genel Ayarlar",
  gameplay_settings: "Oyun Mekaniği Ayarları",
  effects: "Efektler",
  login_and_phone: "Giriş ve Telefon Numarası",
  no_settings_available_for_this_game_type: "Bu oyun türü için ayar yok",
  confirm_reset: "Sıfırlamayı Onayla",
  reset_all_settings_to_default:
    "Tüm ayarları varsayılana sıfırlamak istediğinizden emin misiniz?",
  yes_reset: "Evet, Sıfırla",
  cancel: "İptal",
  settings_reset_successfully: "Ayarlar başarıyla sıfırlandı",
  saved_and_ready_for_preview: "Kaydedildi ve önizlemeye hazır",

  // 2. Giriş & Telefon Sekmesi (TabLogin)
  login_and_phone_settings: "Giriş ve Telefon Ayarları",
  ask_phone_after_game: "Oyun Sonrası Telefon Numarası İste",
  phone_prompt_text: "Telefon Numarası İstek Metni",
  phone_prompt_hint: "Telefon numarası isteme diyaloğunda gösterilen metin",
  submit_button: "Gönder Düğmesi",
  login_dialog_logo: "Giriş Diyaloğu Logosu",
  logo_url: "Logo URL'si",

  // 3. Efektler Sekmesi (TabEffect)
  game_effects_settings: "Oyun Efekt Ayarları",
  sound_enabled: "Sesi Etkinleştir",
  volume: "Ses Seviyesi",
  volume_hint: "Oyun ses seviyesi (0 ile 1 arası)",
  oscillator_type: "Osilatör Tipi",
  jump_sound_freq: "Zıplama Ses Frekansı",
  hit_sound_freq: "Vuruş Ses Frekansı",
  powerup_sound_freq: "Güçlendirme Ses Frekansı",
  move_sound_freq: "Hareket Ses Frekansı",
  combo_base_freq: "Kombo Temel Frekansı",
  sound_durations: "Ses Süreleri",
  move_duration_ms: "Hareket Ses Süresi (ms)",
  jump_duration_ms: "Zıplama Ses Süresi (ms)",
  combo_duration_ms: "Kombo Ses Süresi (ms)",
  hit_duration_ms: "Vuruş Ses Süresi (ms)",
  vibration_enabled: "Titreşimi Etkinleştir",
  particles_enabled: "Partikülleri Etkinleştir",
  explosion_settings: "Patlama Partikül Ayarları",
  particle_count: "Partikül Sayısı",
  gravity: "Yerçekimi",
  friction: "Sürtünme",
  fade_speed: "Solma Hızı",

  // 4. Görseller Sekmesi (TabImages)
  game_images_and_assets: "Oyun Görselleri ve Varlıklar",
  player_image: "Oyuncu Görseli",
  player: "Oyuncu",
  powerup_image: "Güçlendirme Görseli",
  qr_powerup: "QR Güçlendirme",
  enemy_images: "Düşman Görselleri",
  optional_multi: "İsteğe bağlı, birden fazla görsel",
  enemies: "Düşmanlar",
  background_image: "Arka Plan Görseli",
  background: "Arka Plan",
  phone_frame_background: "Telefon Çerçevesi Arka Planı",
  phone_frame: "Telefon Çerçevesi",
  winner_background: "Kazanan Arka Planı",
  winner: "Kazanan",
  ground_image: "Zemin Görseli",
  ground: "Zemin",
  player_character: "Oyuncu Karakteri",
  far_background_layer: "Uzak Arka Plan Katmanı",
  background_far: "Uzak Arka Plan",
  near_background_layer: "Yakın Arka Plan Katmanı",
  background_near: "Yakın Arka Plan",
  obstacle_images: "Engel Görselleri",
  multi_optional: "Birden fazla görsel, isteğe bağlı",
  obstacles: "Engeller",

  // 5. Metinler Sekmesi (TabTexts)
  game_text_contents: "Oyun Metin İçeriği",
  main_screen_texts: "Ana Ekran Metinleri",
  game_title: "Oyun Başlığı",
  game_subtitle: "Oyun Alt Başlığı",
  start_button: "Başlat Düğmesi",
  score_label: "Skor Etiketi",
  game_over_screen: "Oyun Bitti Ekranı",
  game_over_title: "Oyun Bitti Başlığı",
  game_over_subtitle: "Oyun Bitti Alt Başlığı",
  phone_prompt: "Telefon Numarası İsteği",
  restart_button: "Yeniden Başlat Düğmesi",
  hud_and_labels: "HUD ve Etiketler",
  level_label: "Seviye Etiketi",
  combo_label: "Kombo Etiketi",
  final_score_label: "Son Skor Etiketi",
  high_score_label: "En Yüksek Skor Etiketi",
  messages_and_popups: "Mesajlar ve Popup'lar",
  new_record_message: "Yeni Rekor Mesajı",
  fun_random_messages: "Eğlenceli Rastgele Mesajlar",
  add_new_message: "Yeni Mesaj Ekle",

  // 6. Genel Ayarlar Sekmesi (TabSetting)
  general_game_settings: "Genel Oyun Ayarları",
  enemy_spawn_rate: "Düşman Doğma Oranı",
  frames_between_enemies_spawn: "Düşmanlar Arası Kare Sayısı",
  powerup_spawn_rate: "Güçlendirme Doğma Oranı",
  frames_between_qr_spawn: "QR'ler Arası Kare Sayısı",
  win_score_threshold: "Kazanma Skor Eşiği",
  score_required_for_win_or_phone_prompt:
    "Kazanma veya telefon isteme için gereken skor",
  starting_lives: "Başlangıç Can Sayısı",
  high_score_storage_key: "En Yüksek Skor Depolama Anahtarı",
  phone_prompt_score_threshold: "Telefon İstek Skor Eşiği",
  score_to_show_phone_number_form: "Telefon formunu gösterme skoru",
  no_general_settings_available_for_this_game: "Bu oyun için genel ayar yok",

  // 7. Oynanış Sekmesi (TabGamePlay)
  speed_settings: "Hız Ayarları",
  initial_speed: "Başlangıç Hızı",
  max_speed: "Maksimum Hız",
  speed_increase_every_frames: "Her Kaç Kare Hız Artışı",
  speed_increase_amount: "Hız Artış Miktarı",
  distance_per_level: "Seviye Başına Mesafe",
  level_speed_increase: "Seviye Hız Artışı",
  jump_and_physics: "Zıplama ve Fizik",
  jump_force: "Zıplama Kuvveti",
  max_jump_height: "Maksimum Zıplama Yüksekliği",
  lanes_settings: "Şerit Ayarları",
  number_of_lanes: "Şerit Sayısı",
  starting_lane: "Başlangıç Şeridi",
  enemies_spawn: "Düşman Doğması",
  traps_spawn: "Tuzak Doğması",
  min_spawn_interval_ms: "Min Doğma Aralığı (ms)",
  max_spawn_interval_ms: "Max Doğma Aralığı (ms)",
  same_lane_chance: "Aynı Şerit Olasılığı",
  probability_of_spawn_in_player_lane: "Oyuncu Şeridinde Doğma Olasılığı",
  collision_tolerance_px: "Çarpışma Toleransı (px)",
  scoring_rules: "Skorlama Kuralları",
  hit_penalty: "Vuruş Cezası",
  powerup_reward: "Güçlendirme Ödülü",
  score_speed_divider: "Skor Hız Bölücü",
  reset_combo_on_hit: "Vuruşta Kombo Sıfırla",
  camera_settings: "Kamera Ayarları",
  normal_zoom: "Normal Yakınlaştırma",
  hit_zoom: "Vuruş Yakınlaştırması",
  zoom_lerp_speed: "Yakınlaştırma Yumuşatma Hızı",
  game_end_conditions: "Oyun Bitiş Koşulları",
  phone_dialog_score_threshold: "Telefon Diyalog Skor Eşiği",

  // 8. Renkler Sekmesi (TabColors)
  background_gradient: "Arka Plan Gradyanı",
  first_color: "Birinci Renk",
  second_color: "İkinci Renk",
  particle_hit_color: "Vuruş Partikül Rengi",
  particle_powerup_color: "Güçlendirme Partikül Rengi",
  main_background_color: "Ana Arka Plan Rengi",
  ground_color: "Zemin Rengi",
  hud_colors: "HUD Renkleri",
  hud_background: "HUD Arka Planı",
  score_text_color: "Skor Metin Rengi",
  level_text_color: "Seviye Metin Rengi",
  combo_text_color: "Kombo Metin Rengi",
  overlay_colors: "Üst Katman Renkleri",
  backdrop_color: "Arka Perde Rengi",
  card_background: "Kart Arka Planı",
  card_border_color: "Kart Kenar Rengi",
  explosion_particle_color: "Patlama Partikül Rengi",

  // 9. QR Önizleyici (previewerQr)
  gif_tab: "GIF Sekmesi",
  game_tab: "Oyun Sekmesi",
  welcome_gif_upload: "Hoş Geldin GIF Yükle",
  default_welcome: "Varsayılan Hoş Geldin",
  loading_animation: "Yükleme Animasyonu",
  hide_previewer: "Önizleyiciyi Gizle",
  show_previewer: "Önizleyiciyi Göster",
  edit_game_settings: "Oyun Ayarlarını Düzenle",
  save_and_close: "Kaydet ve Kapat",
  animation_scale: "Animasyon Ölçeği",
  animation_slide_x: "Yatay Kaydırma Animasyonu",
  animation_slide_y: "Dikey Kaydırma Animasyonu",
  animation_fade: "Solma Animasyonu",
  game_settings_saved: "Oyun ayarları kaydedildi",
  no_game_configured: "Oyun yapılandırılmamış",

  // 10. GIF Seçici (gifSelector)
  gallery_name: "Galeri Adı",
  change_gallery_name: "Galeri Adını Değiştir",
  add_gif: "GIF Ekle",
  select_gif: "GIF Seç",
  show_gif: "GIF Göster",
  selected_gif: "Seçili GIF",
  count: "Sayı",
  select_category: "Kategori Seç",
  after_typing_enter: "Yazdıktan sonra Enter'a basın",
  search: "Ara",
  no_gif_available: "GIF mevcut değil",
  to_use_ready_gifs_search_category_or_product:
    "Hazır GIF'ler için kategori veya ürün ara",
  max_file_size_2mb: "Maksimum dosya boyutu 2MB",
  upload_file: "Dosya Yükle",
  drag_and_drop_to_upload_or: "Yüklemek için sürükle-bırak veya",
  here: "buraya",
  click: "tıklayın",
  all: "Tümü",
  no_gif_found: "GIF bulunamadı",
  for_adding_file_use_upload_center:
    "Dosya eklemek için yükleme merkezini kullan",
  to_use_external_gif_link_fill_fields: "Dış GIF linki için alanları doldur",
  gif_url_hint: "Tam GIF dosyası URL'si",
  gif_url: "GIF URL'si",
  add: "Ekle",
  title: "Başlık",
  link: "Link",
  description: "Açıklama",
  add_new_gallery: "Yeni Galeri Ekle",
  enter_valid_link: "Geçerli link girin",
  create_gif: "GIF Oluştur",
  ready_gifs: "Hazır GIF'ler",
  gif_gallery: "GIF Galerisi",
  edit_gif: "GIF Düzenle",
  max_background_gif_size_2mb: "Arka plan GIF maksimum 2MB",
  uploaded_successfully: "Başarıyla yüklendi",
  gif_upload_error: "GIF yükleme hatası",

  // 11. Ekstra metinler
  preview: "Önizleme",
  start_button_text: "Başlat Düğmesi Metni",
  game_over_text: "Oyun Bitti Metni",
  game_over_subtext: "Oyun Bitti Alt Metni",
  mobile_prompt_text: "Mobil İstek Metni",
  submit_button_text: "Gönder Düğmesi Metni",
  optional: "İsteğe bağlı",
  game_background: "Oyun Arka Planı",
  background_gradient_colors: "Arka Plan Gradyan Renkleri",
  frames_per_enemy: "Düşman Başına Kare",
  frames_per_powerup: "Güçlendirme Başına Kare",
  win_threshold: "Kazanma Eşiği",
  score_to_win: "Kazanma Skoru",
  your_work_page_name: "Kişisel/Kurumsal Kiwvar",
  "pdf_gallery": {
    "display_mode": "PDF Galeri Görünüm Modu",
    "display_mode_label": "Görünüm Modu",
    "layout": {
      "list": "Liste Görünümü",
      "accordion": "Akordeon Görünümü",
      "slider": "Kaydırıcı (Slider) Görünümü"
    },
    "gallery_name": "Galeri Adı",
    "selected_gallery": "Seçilen Galeri",
    "add_file": "Dosya Ekle",
    "pdf_gallery_label": "PDF Galerisi",
    "select_file": "Dosya Seç",
    "title": "Başlık",
    "pdf_url": "PDF URL'si",
    "description": "Açıklama",
    "add_button": "Ekle",
    "all": "Tümü",
    "image_gallery": "Resim Galerisi",
    "edit_pdf": "PDF Düzenle",
    "preview": "Önizleme",
    "add_pdf_gallery": "PDF Galerisi Ekle",
    "default_gallery_name": "Galeri",
    "gallery_prefix": "Galeri",
    "tabs": {
      "add_file": "Dosya Ekle",
      "pdf_gallery": "PDF Galerisi",
      "link": "Bağlantı"
    },
    "messages": {
      "file_too_large": "Dosya boyutu 10 MB'ı aşamaz.",
      "invalid_file_type": "Lütfen sadece belge ve metin dosyaları seçin.",
      "upload_error": "Dosya yükleme hatası.",
      "only_pdf_txt_allowed": "Sadece PDF ve TXT dosyaları eklenebilir.",
      "title_url_required": "Lütfen başlık ve dosya URL'sini girin."
    }
  },
  "special_info_desc": {
    "textCards": "Kullanıcı bilgilerini, açıklamaları veya kısa özgeçmişleri göstermek için metin kartları ekleyin.",
    "customerClubSettings": "Kullanıcılar numaralarını kaydettikten sonra gönderilecek müşteri kulübü üyelik mesajını ayarlayın.",
    "advanceSettings": "Sayfa davranışını ve özelliklerini özelleştirmek için gelişmiş ve akıllı ayarları yönetin.",
    "voiceGallery": "Sayfada oynatılmak üzere ses dosyalarını yükleyin ve yönetin.",
    "VideoGallery": "Tanıtım, eğitim veya içerik gösterimi için videolar ekleyin ve görüntüleyin.",
    "imageUploader": "Galeride veya sayfanın farklı bölümlerinde görüntülemek üzere resimler yükleyin.",
    "colorPallete": "Sayfa tasarımını ve görünümünü kişiselleştirmek için özel renkler seçin.",
    "socialMediaIcons": "Kullanıcıların hızlı erişimi için sosyal medya bağlantıları ekleyin.",
    "pdfSelector": "Kullanıcıların görüntülemesi veya indirmesi için PDF dosyaları yükleyin ve görüntüleyin.",
    "FeedBack": "Hizmetler veya içerik hakkında kullanıcı yorumları ve geri bildirimleri alın.",
    "consultationNew": "Kullanıcıların talep göndermesi, danışmanlık alması veya iletişime geçmesi için bir form oluşturun."
  },
  "voice_gallery": {
    "autoplay_warning": "Aynı anda sadece bir ses dosyasını otomatik oynatmaya ayarlayabilirsiniz.",
    "autoplay": "Otomatik Oynat"
  },
  "card": {
    "consultation": {
      "title": "Talep Formu"
    },
    "form": {
      "name": "Ad",
      "surname": "Soyad",
      "phone": "Cep Telefonu",
      "email": "E-posta",
      "address": "Adres",
      "national_id": "T.C. Kimlik No",
      "location": "Konum",
      "description": "Açıklama"
    },
    "feedback": {
      "title": "Geri Bildiriminiz",
      "description": "Lütfen aşağıdaki soruları yanıtlayarak hizmetlerimizi geliştirmemize yardımcı olun:",
      "q1": "QRLand hizmetlerinden ne kadar memnunsunuz?",
      "q2": "QRLand hizmetleri ihtiyaçlarınızı ne ölçüde karşıladı?",
      "q3": "Alınan hizmet için ödenen ücret ne kadar makuldu?",
      "q4": "Hizmetlerimizi geliştirmek için düşüncelerinizi bizimle paylaşın."
    },
    "pdf": {
      "gallery_name": "QRLand Teklifler Galerisi",
      "item1_title": "Ürün Tanıtım Teklifi",
      "item1_desc": "QRLand hizmetlerine, akıllı QR kodlarının nasıl çalıştığına, işletmeler için faydalarına ve müşteri etkileşimini artırmaya yönelik kullanım örneklerine kapsamlı giriş.",
      "item2_title": "Dijital Kartvizit Teklifi",
      "item2_desc": "QRLand dijital kartvizit tanıtımı, iletişim bilgilerinin hızlı paylaşımı, sosyal medya bağlantıları ve profesyonel müşteri ilişkileri yönetimi."
    },
    "pdf_selector": {
      "title": "PDF Galerisi",
      "description": "Açıklama"
    },
    "info": {
      "visit_name": "QRLand / Dijital Kartvizit",
      "organization_name": "QRLand",
      "sub_organ": "İlk Dinamik QR Oluşturma Platformu",
      "user_name": "Dijital Kartvizit",
      "fax": "Faks: 02191016066",
      "location_desc": "Tahran, Shariati Cd., Seyed Khandan Köprüsü sonrası, Khandan Çıkmazı, No: 6",
      "postal_code": "Posta Kodu: 1541946815",
      "about_us": "Fiziksel kartvizitlerle ilgili sorunlar nedeniyle, QRLand platformu 'Dijital Kartvizit' adlı bir ürün sundu. Dijital teknolojileri kullanarak fiziksel kartvizitlerin sınırlamalarını tamamen ortadan kaldırmıştır. Aynı zamanda, akıllı alternatiflere geçerek aşırı ağaç kesimini önleyin.",
      "full_address": "İran, Tahran, Tahran Şehri, Bölge 3, Seyed Khandan Mahallesi, Dr. Ali Shariati, Khandan"
    },
    "extra": {
      "field1": "🟥 Kendi işletmeniz için benzer bir dijital kartvizit oluşturun.\n🟧 3 gün boyunca ücretsiz test edin.\n🟨 Ücretsiz kayıt olmak için tıklayın.",
      "field2": "Dijital kartvizitiniz dinamik bir QR koduna sahiptir. Bilgileri istediğiniz zaman cep telefonunuzdan düzenleyebilirsiniz. QR kodunuz düzenlemeden sonra asla değişmez.",
      "field3": "💲 Bu kartvizite sahip olmanın maliyeti 900.000 Tuman'dır."
    },
    "gallery": {
      "name": "Her zaman yanınızda olacağız..."
    },
    "social": {
      "address_hint": "Lütfen adresinizi girin",
      "address_label": "Adres",
      "instagram_hint": "Lütfen Instagram adresinizi girin",
      "instagram_label": "Instagram",
      "whatsapp_hint": "Lütfen WhatsApp adresinizi girin",
      "whatsapp_label": "WhatsApp"
    },
    "video": {
      "item1_name": "Neden QRLand Kartviziti? QRLand'i farklı kılan nedir?",
      "item1_title": "Neden QRLand Kartviziti",
      "item2_name": "QRLand Dijital Kartvizit Tanıtımı",
      "item2_title": "Fiziksel Kartvizitlere En İyi Alternatif"
    },
    "club": {
      "title": "Müşteri Kulübü Üyeliği",
      "description": "Bu sıradan bir müşteri kulübü değil!\nNumaranızı kaydedin"
    },
    "audio": {
      "category_all": "Tümü",
      "item1_title": "Dijital Kartvizitler İçin Kapsamlı Rehber",
      "diff_seconds": "1 saniye önce"
    }
  },
  "pic": {
    "background_image": "Arka Plan Resmi",
    "image_display_type": "Resim Görüntüleme Türü",
    "image_orientation": "Resim Yönü:",
    "horizontal": "Yatay",
    "vertical": "Dikey",
    "change_display_mode": "Görünüm Modunu Değiştir",
    "image": "Resim",
    "uploaded_image": "Yüklenen Resim"
  },
  "send_limit_per_user": "Kullanıcı başına gönderim limiti (0 = sınırsız)",
  "enable_discount_code": "İndirim kodunu etkinleştir",
  "add_new_discount_code": "Yeni indirim kodu ekle",
  "no_discount_codes_added": "Eklenmiş indirim kodu yok",
"toolsManagment": "Yönetim Araçları",
"gateway": {
  "edit": "Düzenle",
  "integrated_edit_all_sections": "Tüm bölümlerin entegre düzenlemesi",
  "show_descriptions": "Açıklamaları göster",
  "search_section_placeholder": "Bölüm ara...",
  "no_section_found": "Bu isimle bir bölüm bulunamadı.",
  "back_to_menu": "Menüye dön",
  "cancel": "İptal",
  "save": "Kaydet"
},
"gridShow": "Izgara Görünümü",
"tableShow": "Tablo Görünümü",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "Açıklama, deneyim veya kısa tanıtım gibi kullanıcı bilgilerini görüntülemek için metin kartları ekleyin.",

    customer_club_settings_description:
      "Kullanıcıların telefon numarasını kaydetmesinden sonra gönderilecek müşteri kulübü üyelik mesajını ayarlayın.",

    advance_settings_description:
      "Sayfanın davranışını ve özelliklerini kişiselleştirmek için gelişmiş ve akıllı ayarları yönetin.",

    voice_gallery_description:
      "Sayfada oynatılacak ses dosyalarını yükleyin ve yönetin.",

    video_gallery_description:
      "Tanıtım, eğitim veya içerik gösterimi için videolar ekleyin ve görüntüleyin.",

    image_uploader_description:
      "Galeride veya sayfanın farklı bölümlerinde görüntülenecek görselleri yükleyin.",

    color_palette_description:
      "Sayfanın görünümünü ve tasarımını kişiselleştirmek için özel renkler seçin.",

    social_media_icons_description:
      "Hızlı erişim için sosyal medya bağlantıları ekleyin.",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "Kompleksin ana banner görselini yükleyin veya değiştirin.",

    logo_select_description:
      "İşletmenin veya kompleksin logosunu ayarlayın.",

    service_description:
      "Kompleksin ana hizmetlerini ve olanaklarını yönetin.",

    faq_description:
      "Müşterilerin sıkça sorduğu soruları ekleyin ve düzenleyin.",

    blog_description:
      "Kompleksle ilgili makaleler ve haberler ekleyin.",

    floor_description:
      "Kompleksin katlarını ve mağaza birimlerini yönetin.",

    text_cards_description:
      "Açıklamaları ve kullanıcıyla ilgili bilgileri girin.",

    social_media_icons_description:
      "Müşterilerle iletişim için sosyal medya bağlantıları ekleyin.",

    pic_selector_description:
      "Kompleksin ve mağazaların görsellerini ekleyin.",

    video_gallery_description:
      "Tanıtım veya reklam videolarını yükleyin.",

    pdf_selector_description:
      "Katalogları ve bilgilendirici dosyaları yönetin.",

    feedback_description:
      "Ziyaretçi görüşleri ve geri bildirimleri bölümünü yönetin.",

    consultation_new_description:
      "Müşteri bilgilerini veya taleplerini toplamak için formu yönetin.",

    service_section_description:
      "Özel hizmet bölümleri oluşturun.",

    counter_service_description:
      "Kompleksin istatistiklerini ve başarılarını sayısal olarak görüntüleyin.",

    counter_description:
      "Etkinlikler veya açılış için geri sayım ayarlayın.",

    personnel_description:
      "Yöneticileri ve ekibin önemli üyelerini tanıtın.",

    customer_club_settings_description:
      "SMS ve müşteri kulübü kayıt ayarlarını yönetin.",

    work_sheet_description:
      "Kompleksin çalışma saatlerini ve faaliyet günlerini belirleyin.",

    pallet_commercial_description:
      "Sayfanın renklerini ve görsel stilini ayarlayın.",

    default_description:
      "İşletme sayfasına {title} bölümünü ekleyin ve yönetin.",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "Giriş sayfasını yapılandırın ve mağaza logosunu değiştirin.",

  banner_selector_description:
    "Mağaza bannerlarını yükleyin ve yönetin.",

  text_cards_description:
    "Metin bilgileri, tanıtım ve hakkımızda.",

  product_description:
    "Ürünleri oluşturun, yönetin ve düzenleyin.",

  special_category_manager_description:
    "Özel teklifler ve indirimli ürün kategorilerini yönetin.",

  social_media_icons_description:
    "Mağazanın sosyal medya bağlantılarını ekleyin.",

  blog_description:
    "Blog yazılarını yazın ve yönetin.",

  service_description:
    "Sunulan ek hizmetleri tanıtın.",

  faq_description:
    "Sıkça sorulan sorular listesini görüntüleyin ve yönetin.",

  pic_selector_description:
    "Mağaza görsel galerisini yükleyin ve yönetin.",

  video_gallery_description:
    "Tanıtım ve reklam videolarını yükleyin.",

  pdf_selector_description:
    "Kılavuz dosyaları veya PDF katalogları sunun.",

  feedback_description:
    "Müşteri yorumlarını ve geri bildirimlerini yönetin.",

  counter_description:
    "Etkinlikler veya özel teklifler için geri sayım ayarlayın.",

  consultation_description:
    "Talep veya danışmanlık başvuruları almak için form oluşturun.",

  service_section_description:
    "Özel hizmet bölümlerini yönetin.",

  counter_service_description:
    "Mağazanın istatistiklerini, verilerini ve başarılarını görüntüleyin.",

  personnel_description:
    "Ekip üyelerini ve mağaza personelini tanıtın.",

  work_sheet_description:
    "Mağazanın çalışma günlerini ve saatlerini ayarlayın.",

  default_description:
    "Mağaza sayfasına {title} bölümünü ekleyin ve yönetin.",
},
edit_gold_special_info_single: {
  product_info_title: "Ürün Bilgileri",
  product_info_description:
    "Ürünün temel bilgilerini, özelliklerini, fiyatını ve ek açıklamalarını ekleyin ve düzenleyin.",

  asset_management_title: "Varlık Yönetimi",
  asset_management_description:
    "Varlıkları yönetin, değer atayın ve ürünle ilişkili cüzdan bilgilerini yönetin.",

  add_social_networks_title: "Sosyal Ağları Ekle",
  social_networks_title: "Sosyal Ağlar",
  social_media_description:
    "Müşterilerin markanızla daha hızlı iletişim kurabilmesi için sosyal medya bağlantıları ekleyin.",

  add_video_title: "Video Ekle",
  video_description:
    "Ürün için tanıtım, eğitim veya reklam videoları ekleyin ve görüntüleyin.",

  add_image_title: "Görsel Ekle",
  image_description:
    "Ürünü galeride daha iyi göstermek için farklı açılardan yüksek kaliteli görseller yükleyin.",

  select_color_title: "Renk Seç",
  color_palette_description:
    "Ürün sayfasının renk düzenini ve görünümünü marka kimliğinize uygun şekilde kişiselleştirin.",
},

edit_multicard_special_info_single: {
  add_account_description:
    "Adı, profil fotoğrafını ve arka planı düzenleyin",

  management_account_description:
    "Banka hesabı bilgilerini ekleyin ve düzenleyin",

  management_color_description:
    "Butonların ve arka planın renk temasını değiştirin",
},

edit_feedback_special_single: {
  base_info_description:
    "Temel bilgileri ve form başlığını düzenleyin",

  image_uploader_description:
    "Geri bildirim formu logosunu yükleyin ve yönetin",

  feedback_description:
    "Alanları yapılandırın ve geri bildirim formunu yönetin",

  color_palette_description:
    "Renk temasını seçin ve formun görünümünü kişiselleştirin",
},

edit_gitf_special_info_single: {
  default_description:
    "Anılar QR çerçevesindeki {title} bölümünü ekleyin ve yönetin.",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "Kataloğun temel bilgileri, başlığı ve açıklaması",

  image_uploader_description:
    "Logo veya ana görseli yükleyin ve yönetin",

  pic_selector_description:
    "Katalog veya broşür sayfalarını yükleyin ve yönetin",

  social_media_icons_description:
    "Sosyal medya bağlantılarını ekleyin ve yönetin",

  color_palette_description:
    "Renk temasını seçin ve görünümü kişiselleştirin",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "Farklı bir kategorilendirme uygulamak için şablon seçin",

  login_config_description:
    "Giriş sayfası ayarları ve görünümü",

  general_settings_description:
    "Para birimi ve işletme türü için genel ayarlar.",

  banner_selector_description:
    "Sayfanın üst kısmında görüntülenecek banner görselini yükleyin ve seçin; menünün veya profilin görünümünü daha çekici hale getirin.",

  product_description:
    "Görsel, fiyat ve özel açıklama gibi ayrıntılarla ürün veya hizmet oluşturun ve yönetin.",

  text_cards_description:
    "Genel açıklama, deneyim veya kısa tanıtım gibi temel kullanıcı bilgilerini görüntülemek için metin kartları ekleyin.",

  social_media_description:
    "Daha hızlı iletişim ve müşterilerin daha kolay erişimi için sosyal medya bağlantıları ve simgeleri ekleyin.",

  photo_gallery_description:
    "Ürün fotoğraflarını, çalışma örneklerini veya işletme ortamını göstermek için bir görsel galerisi oluşturun.",

  video_gallery_description:
    "Reklam videolarını, eğitim videolarını veya tanıtımları göstermek için video galerisi ekleyin.",

  feedback_description:
    "Önceki müşterilerin yorumlarını, geri bildirimlerini ve memnuniyet düzeylerini göstermek için bir bölüm oluşturun.",

  working_hours_description:
    "Çalışma saatlerini ve işletmenin açık olduğu zamanları belirleyin.",
},

edit_pdf_special_info_single: {
  base_info_title: "Bilgiler",
  base_info_description:
    "Genel açıklama, deneyim veya kısa tanıtım gibi temel kullanıcı bilgilerini görüntülemek için metin kartları ekleyin.",

  image_uploader_title: "Logo Yükle",
  image_uploader_description:
    "Sayfada gösterilecek logo veya profil fotoğrafı olarak kullanılacak bir görsel yükleyin ve seçin.",

  pdf_selector_title: "PDF Galerisi Ekle",
  pdf_selector_description:
    "PDF veya metin dosyalarından oluşan bir galeri oluşturun; her dosya için kapak görseli ve özel açıklama ekleyebilirsiniz.",

  social_media_icons_title: "Sosyal Ağları Ekle",
  social_media_icons_description:
    "Daha hızlı iletişim ve kolay erişim için sosyal medya bağlantıları ve simgeleri ekleyin.",

  color_palette_title: "Renk Seç",
  color_palette_description:
    "Tema rengini seçin ve öğelerin görünümünü markanıza uygun şekilde kişiselleştirin.",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "Fotoğraf galerisindeki {title} bölümünü ekleyin ve yönetin.",
},

edi_social_special_info_single: {
  banner_selector_title: "Fotoğraf Yükle",
  banner_selector_description:
    "Sosyal medya sayfanızın üst kısmındaki arka plan görselini veya bannerı seçin ve yükleyin.",

  base_info_title: "Bilgiler",
  base_info_description:
    "Ana başlık ve profil açıklaması gibi temel bilgileri girin.",

  image_uploader_title: "Logo Yükle",
  image_uploader_description:
    "Kişisel veya marka logonuzu ya da profil görselinizi sayfada göstermek için yükleyin.",

  social_media_icons_title: "Sosyal Ağları Ekle",
  social_media_icons_description:
    "Instagram, Telegram, WhatsApp, LinkedIn ve diğer sosyal ağların bağlantılarını ekleyerek simgelerinin sayfada görünmesini sağlayın.",
},

edit_text_special_info_single: {
  base_info_title: "QR Bilgileri ve Metinler",
  base_info_subtitle: "Ana Metin ve Metin Alanları",
  base_info_description:
    "Başlığı, Hakkımızda ana metnini ve özel QR metin alanlarını düzenleyin",

  image_uploader_title: "Logo ve Arka Plan Görseli",
  image_uploader_subtitle: "Görsel Ayarları",
  image_uploader_description:
    "Özel logoyu veya kart arka plan görselini yükleyin ve değiştirin",

  color_palette_subtitle: "Görünümü Kişiselleştir",
  color_palette_description:
    "Okunabilirliği ve kontrastı artırmak için başlık, arka plan ve metin renklerini ayarlayın",
},

edit_video_special_info_single: {
  base_info_title: "Bilgiler",
  base_info_description:
    "Başlık ve QR kod adresi gibi temel bilgileri düzenleyin.",

  image_uploader_title: "Logo Yükle",
  image_uploader_description:
    "Sayfa logosu görselini yükleyin ve yönetin.",

  video_gallery_title: "Video Galerisi",
  video_gallery_description:
    "Galeride gösterilecek videoları ekleyin, düzenleyin ve yönetin.",

  social_media_icons_title: "Sosyal Ağları Ekle",
  social_media_icons_description:
    "Sosyal medya bağlantıları ve iletişim yöntemleri ekleyin.",

  color_palette_title: "Renk Seç",
  color_palette_description:
    "Renk düzenini değiştirin ve sayfa için uygun bir renk teması seçin.",
},

edit_product_special_info_single: {
  factory_info_description:
    "Şirket bilgilerini ve tanıtımını düzenleyin",

  single_product_editor_description:
    "Temel bilgileri ve Satın Al gibi işlem butonlarını düzenleyin",

  customer_club_settings_description:
    "Müşteri kulübü ayarları ve SMS gönderimi",

  advance_settings_description:
    "Gelişmiş görüntüleme ve güvenlik ayarları",

  features_description:
    "Ürün özelliklerini ve teknik özelliklerini yönetin",

  voice_gallery_description:
    "Podcast ve ses dosyalarını yükleyin ve yönetin",

  image_uploader_description:
    "Ürün görsel galerisini yükleyin ve yönetin",

  video_gallery_description:
    "İlgili ürün video galerisini ekleyin ve yönetin",

  social_media_icons_description:
    "Sosyal medya bağlantılarını ekleyin ve yönetin",

  color_palette_description:
    "Renk temasını seçin ve şablonu kişiselleştirin",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "Üretim şirketinin genel bilgilerini ve tanıtımını girin.",

  single_product_editor_description:
    "Temel bilgileri, güven rozeti ve ürün satın alma butonunu ayarlayın.",

  customer_club_settings_description:
    "SMS ayarları ve müşterilerin kulübe üyeliği.",

  features_description:
    "Ürün özelliklerini ve teknik özelliklerini ekleyin.",

  feedback_description:
    "Alıcı yorumları ve geri bildirim bölümü.",

  consultation_description:
    "Danışmanlık talebi veya sipariş formu.",

  advance_settings_description:
    "Gelişmiş ve akıllı ürün görüntüleme ayarları.",

  voice_gallery_description:
    "Ürün tanıtımı veya rehberi için ses dosyaları.",

  image_uploader_description:
    "Ürünün farklı görsellerini yükleyin.",

  video_gallery_description:
    "Ürünle ilgili tanıtım veya eğitim videoları.",

  social_media_icons_description:
    "Daha iyi iletişim için sosyal medya bağlantıları.",

  color_palette_description:
    "Ürün sayfasının renklerini ve görsel stilini ayarlayın.",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "Ses galerisi temel bilgileri ve özellikleri",

  image_uploader_description:
    "Logo veya kapak görselini yükleyin ve yönetin",

  voice_gallery_description:
    "Ses dosyalarını ve podcastleri yükleyin ve yönetin",

  color_palette_description:
    "Renk temasını seçin ve galeri görünümünü kişiselleştirin",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "Galeri başlığını ve açıklamasını düzenleyin",

  image_uploader_description:
    "Logo ve ana kapağı yükleyin ve yönetin",

  voice_gallery_acc_description:
    "Ses dosyalarını yükleyin, silin ve yönetin",

  social_media_icons_description:
    "Sosyal medya bağlantılarını ekleyin ve yönetin",

  color_palette_description:
    "Renk temasını seçin ve galeri görünümünü kişiselleştirin",
},
edit_bpage_special_info_special: {
  advertising_sites: "Reklam siteleri",
stores: "Mağazalar",

divar: "Divar",
divar_hint: "Divar bağlantınızı girin",

sheypoor: "Sheypoor",
sheypoor_hint: "Sheypoor bağlantınızı girin",

digikala: "Digikala",
digikala_hint: "Digikala bağlantınızı girin",

basalam: "Basalam",
basalam_hint: "Basalam bağlantınızı girin",

snappshop: "SnappShop",
snappshop_hint: "SnappShop bağlantınızı girin",

technolife: "Technolife",
technolife_hint: "Technolife bağlantınızı girin",

torob: "Torob",
torob_hint: "Torob bağlantınızı girin",

emalls: "eMalls",
emalls_hint: "eMalls bağlantınızı girin",

cafebazaar: "Cafe Bazaar",
cafebazaar_hint: "Cafe Bazaar bağlantınızı girin",

googleplay: "Google Play",
googleplay_hint: "Google Play bağlantınızı girin",

samsung: "Samsung",
samsung_hint: "Galaxy Store bağlantınızı girin",

apple: "Apple",
apple_hint: "App Store bağlantınızı girin",
  add_audio_gallery: "Ses dosyaları galerisi ekle",
  factory_information: "İşletme bilgileri",
  trust_badge: "Güven rozeti",
  buy_button: "Satın al butonu",
  smart_settings: "Akıllı ayarlar",
  add_product_feature: "Ürün özelliği ekle",
  product_features: "Ürün özellikleri",
  add_audio_file: "Ses dosyası ekle",
  audio_gallery: "Ses galerisi",
  text: "Metin",
  logo_background: "Logo / arka plan",
  select_color: "Renk seç",
  information: "Bilgiler",
  luck_management: "Şans yönetimi",
  registration_management: "Kayıt yönetimi",
  turning: "Sayfa çevirme",
  slider: "Kaydırıcı",
  vertical: "Dikey",
  upload_catalog_brochure_images: "Katalog / broşür görsellerini yükle",
  upload_banner: "Banner yükle",
  upload_header_image: "Başlık görselini yükle",
  upload_image: "Görsel yükle",
  services: "Hizmetler",
  faq: "Sıkça sorulan sorular",
  blog: "Blog",
  create_product: "Ürün oluştur",
  user_information: "Kullanıcı bilgileri",
  add_social_media: "Sosyal medya ekle",
  photo_gallery: "Fotoğraf galerisi",
  video_gallery: "Video galerisi",
  pdf_gallery: "PDF galerisi",
  feedback: "Geri bildirim",
  request_form: "Talep formu",
  create_section: "Bölüm oluştur",
  achievements: "Başarılar",
  countdown: "Geri sayım",
  team_members: "Ekip üyeleri",
  working_hours: "Çalışma saatleri",
  upload_logo: "Logo yükle",
  create_store: "Mağaza oluştur",
  customer_club_membership_sms: "Müşteri kulübü üyelik SMS'i",
  product_information: "Ürün bilgileri",
  asset_management: "Varlık yönetimi",
  social_media: "Sosyal medya",
  add_video: "Video ekle",
  add_image: "Görsel ekle",
  add_user_information: "Kullanıcı bilgisi ekle",
  manage_accounts: "Hesapları yönet",
  manage_color: "Renkleri yönet",
  download_qr: "QR kodunu indir",
  add_store: "Mağaza ekle",
  manage_appointments: "Randevuları yönet",
},
edit_gift_special_info_special: {
  gift_story: "Hediye hikayesi",
  profile_image: "Profil resmi",
  featured_images: "Öne çıkan görseller",
  image_gallery: "Görsel galerisi",
  video_gallery: "Video galerisi",
  add_audio_file: "Ses dosyası ekle",
  select_color: "Renk seç",
},
edit_insurance_special_info_special: {
  login_settings: "Giriş ayarları",
  shop_logo_images: "Mağaza logosu ve görselleri",
  login_page_information: "Giriş sayfası bilgileri",
  upload_banner_logo: "Banner ve logo yükle",
  user_information: "Kullanıcı bilgileri",
  manage_products_insurance: "Ürünleri / sigortaları yönet",
  special_sale: "Özel satış",
  add_social_media: "Sosyal medya ekle",
  blog: "Blog",
  services: "Hizmetler",
  faq: "Sıkça sorulan sorular",
  photo_gallery: "Fotoğraf galerisi",
  video_gallery: "Video galerisi",
  pdf_gallery: "PDF galerisi",
  feedback: "Geri bildirim",
  countdown: "Geri sayım",
  request_form: "Talep formu",
  create_section: "Bölüm oluştur",
  achievements: "Başarılar",
  team_members: "Ekip üyeleri",
  working_hours: "Çalışma saatleri",
  shop_login_description: "Mağaza logosu ve giriş sayfası ayarları",
  insurance_manage_description: "Ürün / hizmet listesini ekle ve düzenle",
  banner_description: "Başlık görsellerini yönet",
},
};
